export const languageChineseTraditional = {
    "formating": {
        "main": "主要提示詞",
        "jailbreak": "越獄提示詞",
        "chats": "過往對話",
        "lorebook": "Lorebook",
        "globalNote": "全域備註",
        "authorNote": "作者備註",
        "lastChat": "最近一次對話",
        "description": "角色描述",
        "personaPrompt": "使用者人設",
        "plain": "一般提示詞",
        "memory": "Supa/HypaMemory",
        "postEverything": "結尾注入提示詞",
    },
    "errors": {
        "toomuchtoken": "錯誤：最低所需 Token 數已超過最大上下文長度",
        "unknownModel": "錯誤：無法識別所選的模型",
        "httpError": "錯誤：請求發生錯誤：",
        "noData": "檔案格式錯誤或資料已損毀",
        "onlyOneChat": "至少需要保留一個對話",
        "alreadyCharInGroup": "該群組中已經有一個同名角色",
        "noUserIcon": "請先設定您的個人頭像",
        "emptyText": "文字內容為空",
        "wrongPassword": "密碼錯誤",
        "vertexAuthError": "缺少 Vertex AI 驗證資訊",
        "networkFetch": "通常是網路連線不穩定，或伺服器暫時無法使用所致",
        "networkFetchWeb":
            "這可能是 CORS 錯誤。由於瀏覽器限制，此問題只會在網頁版發生。請嘗試使用桌面本機版或其他版本的 Risuai",
        "networkFetchPlain": "這可能是一般 Fetch 錯誤。請嘗試在設定中停用「強制一般 Fetch」",
        "requestLogRemoved": "此請求記錄已被移除",
        "requestLogRemovedDesc": "重新整理或重新載入用戶端後，請求記錄會被移除",
        "coldStorageWriteFailed": "冷儲存寫入失敗。您的對話資料已被保留",
        "coldStorageVerifyFailed": "冷儲存驗證失敗。您的對話資料已被保留",
        "coldStorageRestoreFailed": "無法載入冷儲存資料。受影響角色的資料可能已永久遺失",
        "coldStorageIncompleteBackupConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `${characterNames || "未知角色"} 的冷儲存資料遺失或無效。${unresolvedCount > 0 ? `有 ${unresolvedCount} 個項目無法連結到角色。` : ""}\n\n若繼續，此備份將缺少 ${unavailableCount} 個冷儲存項目，受影響的角色或對話資料可能無法從此備份復原。\n\n仍要建立不完整的備份嗎？`,
        "coldStorageIncompleteRestoreConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `無法復原 ${characterNames || "未知角色"} 的冷儲存資料。${unresolvedCount > 0 ? `有 ${unresolvedCount} 個項目無法連結到角色。` : ""}\n\n若繼續，${unavailableCount} 個冷儲存項目將無法使用，受影響的角色或對話資料可能永久遺失。\n\n仍要繼續不完整的復原嗎？`,
    },
    "showHelp": "顯示說明",
    "help": {
        "model": "聊天時使用的主要模型",
        "submodel": "輔助模型用於分析情緒立繪、產生自動建議等功能",
        "oaiapikey": "OpenAI 的 API 金鑰，可在 https://platform.openai.com/account/api-keys 取得",
        "mainprompt": "主要提示詞用於決定模型的預設行為",
        "jailbreak": "啟用角色越獄後，將使用越獄提示詞",
        "globalNote": "會強烈影響模型行為的備註，也稱為 UJB；適用於所有角色",
        "autoSuggest": "用於自動建議使用者回應時生成選項的提示詞",
        "formatOrder": "提示詞的排列順序。越靠下的區塊對模型的影響越大",
        "forceUrl": "此欄位不為空時，請求將發送至您輸入的 URL",
        "tempature":
            "較低的數值會使角色更緊密地遵循提示詞，但回應可能顯得生硬且機械化。\n較高的數值會增加創意表現，但角色回應也更容易變得不穩定",
        "frequencyPenalty": "較高的數值可以減少單次回應中的重複用詞，但數值過高也可能使角色回應變得不穩定",
        "presensePenalty": "較高的數值可以減少整體上下文中的重複用詞，但數值過高也可能使角色回應變得不穩定",
        "sdProvider": "圖片生成供應商",
        "msgSound": "角色回應時播放「叮」聲",
        "charDesc": "角色的簡要描述。這會影響角色的回應方式",
        "charFirstMessage": "角色的開局訊息，會大幅影響角色的回應方式",
        "charNote": "會強烈影響模型行為的備註，只套用於目前角色，也稱為 UJB",
        "toggleNsfw": "啟用或停用越獄提示詞",
        "lorebook": "Lorebook 是由使用者建立的條目資料庫。當上下文符合條目的啟用條件時，該條目的內容才會加入送給模型的提示詞",
        "loreName": "Lorebook 條目的名稱本身不會影響 AI 回應",
        "loreActivationKey": "當上下文中包含任一啟用關鍵字時，該條目會被啟用並送入提示詞。請以逗號分隔多個關鍵字",
        "loreorder": "插入順序越高，條目的提示詞優先順序也越高；同時啟用大量 Lorebook 條目時，也較不容易因 Token 限制而被截除",
        "bias": "Bias 是一組字串與出現機率權重的對應設定，用於修改特定字串出現的機率。\n數值範圍可為 -100 到 100；數值越高越容易出現，越低則越不容易出現。\n另外，在部分模型中設為 -101 時，可作為「強制禁止詞」。\n警告：若 Tokenizer 設定錯誤，可能無法正常運作",
        "emotion":
            "情緒立繪會依角色回應中分析出的情緒顯示對應圖片。情緒名稱必須使用文字關鍵字*（如 joy、happy、fear 等）*。若存在名為 **neutral** 的情緒，會作為預設情緒。至少需要 4 張圖片才能正常運作",
        "imggen": "分析對話後，將提示詞套用至 {{slot}}",
        "regexScript":
            "Regex 腳本是一個自訂工具，可將符合 IN 的字串替換為 OUT。\n\n共有四種類型：" +
            "\n\n- **修改輸入（Modify Input）**：修改使用者輸入" +
            "\n\n- **修改輸出（Modify Output）**：修改角色輸出" +
            "\n\n- **修改請求資料（Modify Request Data）**：修改送出時的目前對話資料" +
            "\n\n- **修改顯示（Modify Display）**：只修改畫面上顯示的文字，不變更實際對話資料" +
            "\n\nIN 必須是不含旗標、且開頭與結尾沒有斜線的正規表達式。\n\nOUT 是可包含替換模式的字串。可用模式如下：" +
            "\n\n- $$\n\n    - 插入 $" +
            "\n\n- $&\n\n    - 插入比對到的子字串。" +
            "\n\n- $`\n\n    - 插入比對結果之前的內容。" +
            "\n\n- $1\n\n    - 插入第一個比對群組，也可使用 2、3 等其他數字。" +
            "\n\n- $(name)\n\n    - 插入命名群組" +
            "\n\n除了原生支援的旗標外，亦可使用下列提供給進階使用者的旗標：" +
            "\n\n- `<inject>`：將結果注入目前字串。" +
            "\n- `<move_top>`：將結果移至字串頂端。" +
            "\n- `<move_bottom>`：將結果移至字串底端。" +
            "\n- `<repeat_back>`：找不到符合項目時，沿用上一個比對結果。" +
            "\n- `<order n>`：設定結果順序。數值越高越優先顯示；`n` 為數字（例如 `<order 1>`）。未設定時預設為 0。" +
            "\n- `<cbs>`：解析 IN 中的大括號語法。" +
            "\n\n可與原生旗標組合，例如：`gi<cbs><move_top>`",
        "experimental": "此為實驗性功能，可能不穩定",
        "oogaboogaURL":
            "若您的 WebUI 支援舊版 API，URL 應類似 *https:.../run/textgen*。\n\n" +
            "若 WebUI 支援新版 API，URL 應類似 *https://.../api/v1/generate*；請使用 API 伺服器作為主機，並在參數中加入 --api",
        "exampleMessage":
            "示範對話會影響角色輸出，但不會永久佔用 Token。" +
            "\n\n對話格式範例：" +
            "\n\n```\n<START>\n{{user}}: hi\n{{char}}: hello\n<START>\n{{user}}: hi\nHaruhi: hello\n```" +
            "\n\n```<START>``` 代表一段新對話的開始",
        "creatorQuotes": "顯示在開局訊息上方的創作者留言，用來向使用者說明卡片資訊；此內容不會加入提示詞",
        "systemPrompt": "此欄位不為空時，會取代設定中的主要提示詞",
        "chatNote": "對模型行為有強烈影響的備註，嵌入於目前對話中，也稱為記憶或 UJB",
        "personality": "角色性格的簡要描述。\n\n**不建議使用此欄位，請改寫在角色描述中**",
        "scenario": "角色情境的簡要描述。\n\n**不建議使用此欄位，請改寫在角色描述中**",
        "utilityBot": "啟用後會忽略主要提示詞、越獄提示詞與其他提示詞。適用於工具型 Bot，而非角色扮演",
        "loreSelective": "啟用選擇性模式後，必須同時符合啟用關鍵字與次要關鍵字，才會啟用該 Lorebook 條目",
        "loreRandomActivation":
            "啟用機率條件後，只要 Lorebook 條目的其他條件皆成立，每次送出對話時就會依「機率」設定值決定是否啟用",
        "additionalAssets":
            "在對話中顯示的額外資源。\n\n - 使用 `{{raw::<asset name>}}` 取得資源路徑。\n - 使用 `{{image::<asset name>}}` 顯示圖片。\n - 使用 `{{video::<asset name>}}` 顯示影片。\n - 使用 `{{audio::<asset name>}}` 播放音訊。\n    - 建議放在背景 HTML 中",
        "superMemory":
            "SupaMemory 會將摘要資料提供給 AI，讓角色能記住更多內容。\n\n" +
            "SupaMemory 模型負責摘要文字。若使用輔助模型，建議選擇未過濾、可處理超過 2000 Token，且摘要能力良好的模型；否則不建議使用輔助模型。\n\n" +
            "SupaMemory 提示詞決定摘要時要送出的提示詞。留空會使用預設提示詞，建議維持空白。\n\n" +
            "全部設定完成後，可在角色設定中啟用",
        "replaceGlobalNote": "此欄位不為空時，會以此內容取代目前的全域備註",
        "backgroundHTML":
            "會插入對話畫面背景的 Markdown／HTML 內容。\n\n也可搭配額外資源，例如使用 `{{audio::<asset name}}` 播放背景音樂。" +
            "\n\n另外還可使用：" +
            "\n - `{{bg::<asset name>}}`：將指定資源顯示為背景圖片",
        "additionalText": "系統會將內容依兩個換行分段，並根據目前對話進行相似度搜尋，選出最多 3 個最相關的段落加入角色描述。可在此放置較長內容",
        "charjs": "會隨角色一起執行的 JavaScript 程式碼。可參考 `https://github.com/kwaroran/Risuai/blob/main/src/etc/example-char.js`。基於安全性，目前不建議使用；匯出時也不會包含此內容",
        "romanizer":
            "Romanizer 會在送出資料時，將非拉丁文字轉寫為拉丁字母，以減少 Token 使用量。這可能使模型輸出與原始文字不同。若對話本身使用拉丁字元，不建議啟用",
        "inlayImages": "啟用後，可將圖片內嵌至對話；若 AI 支援圖片輸入，也能讀取這些圖片",
        "metrica":
            "Metric Systemizer 會在送出請求時將公制轉成英制，並在顯示輸出時再轉回公制，讓模型以英制處理，而使用者仍看到公制。若對話原本使用英制，不建議啟用",
        "lorePlus": "Lorebook+ 是使用向量資料庫取代單純字串比對的實驗性功能，可改善角色卡製作流程與 Lorebook 條目的比對效果",
        "topP": "Top P 是核取樣（nucleus sampling）的機率門檻。模型會依 Token 機率由高到低累加，取涵蓋至少 top_p 累積機率的最小 Token 集合，再從該集合中取樣",
        "openAIFixer": "OpenAI Fixer 是用來修正部分 OpenAI 問題的外掛",
        "sayNothing": "啟用後，若沒有輸入任何文字，會自動輸入「say nothing」",
        "showUnrecommended": "啟用後會顯示不建議使用或已棄用的設定。**不建議使用這些設定**",
        "streamingDisplayOptimizationMode":
            "在長篇串流回應搭配大量後處理（例如 Regex 腳本）時，降低畫面顯示延遲。對行動裝置或低階裝置尤其有幫助。\n\n" +
            "關閉時維持一般行為，但每收到一個 Token 都會執行後處理，可能造成明顯負擔。\n\n" +
            "平衡模式會降低負載，只在短時間間隔（約每 0.125 秒）嘗試執行後處理。\n\n" +
            "強力模式與平衡模式類似，但串流期間完全略過後處理，等串流結束後再執行一次。\n\n" +
            "此為實驗性功能，部分功能可能因此出現非預期行為",
        "imageCompression": "啟用後，匯出角色時會壓縮圖片。若動態圖片無法正常運作，請嘗試停用",
        "useExperimental": "啟用後會顯示部分實驗性功能",
        "forceProxyAsOpenAI": "啟用後，使用反向代理時會強制採用 OpenAI 格式",
        "forcePlainFetch": "啟用後會使用瀏覽器 Fetch API，而非原生 HTTP 請求；這可能造成 CORS 錯誤",
        "autoFillRequestURL": "啟用後會依目前模型自動填入對應的請求 URL",
        "localNetworkModeDesc":
            "透過本機執行環境轉送私有網路／LAN 的模型 URL，而不是由瀏覽器直接 Fetch。\n\n" +
            "**用途**\n" +
            "- 避免瀏覽器對 `192.168.x.x`、`10.x.x.x`、`localhost`、`.local` 等本機位址的私有網路／CORS 限制。\n" +
            "- 在 Node 自架模式中，降低本機推理首 Token 較慢時發生逾時的風險。\n\n" +
            "**運作方式**\n" +
            "- 只有在啟用本機網路模式，且目標 URL 被判定為本機／私有網路位址時才會套用。\n" +
            "- Node 自架：串流會優先使用實驗性的 Job + WebSocket 中繼（失敗時改用 `/proxy2`）；非串流使用 `/proxy2`。\n" +
            "- Tauri：使用原生直接連線路徑。\n" +
            "- 公開網頁模式：基於設計，不允許直接存取本機／私有網路位址。\n\n" +
            "**限制**\n" +
            "- 僅適用於 OpenAI 相容的請求路徑。\n" +
            "- 無法繞過兩個公開網域之間的 Cloudflare origin 限制。\n" +
            "- 必須使用您自己的自架 URL（`globalThis.__NODE__ === true`）此功能才會生效",
        "chainOfThought": "啟用後會加入 Chain of Thought 提示詞",
        "gptVisionQuality": "用於設定圖片辨識模型的品質。品質越高，辨識越準確，但也會使用更多 Token",
        "genTimes":
            "設定支援此功能的模型一次要產生幾個回應。第一個以外的回應會預先快取，供之後「重新產生」使用。這有機會降低成本；但若沒有使用這些預先產生的回應，反而可能增加成本",
        "requestretrys": "設定請求失敗時的重試次數",
        "chatLoadInitialPages": "開啟對話畫面時，最初顯示的近期訊息數量。數值越高可立即顯示更多歷史紀錄，但開啟長對話時負擔也會增加",
        "chatLoadAdditionalPages": "每次捲動到頂端時額外載入並顯示的舊訊息數量。數值越高可減少重複載入次數，但每次載入的負擔也會增加",
        "emotionPrompt": "設定用於偵測情緒的提示詞。留空時使用預設提示詞",
        "removePunctuationHypa": "啟用後，在執行 HypaMemory 前移除標點符號",
        "additionalParams":
            '加入 Request Body 的額外參數。若要排除某個參數，可將值設為 `{{none}}`。若要加入 Header 而非 Request Body，可在鍵名前加上 `header::`，例如 `header::Authorization`。若要將值作為 JSON，可在值前加上 `json::`，例如 `json::{"key":"value"}`；否則會自動判斷值的型別',
        "antiClaudeOverload":
            "發生 Claude 過載時，Risuai 會嘗試以相同提示詞繼續請求，降低再次發生的機率。僅適用於串流回應；非官方 API 端點可能無法運作",
        "triggerScript":
            'Trigger 腳本是在符合條件時執行的自訂腳本，可修改對話資料、執行指令、變更變數等；可用功能依觸發時機而異。也可透過 {{button::顯示文字::TriggerName}} 按鈕執行，或在 HTML 按鈕加入 `risu-trigger="<TriggerName>"` 屬性',
        "autoContinueChat": "啟用後，若回應結尾沒有標點符號，會嘗試自動繼續生成回應。**請勿用於不使用標點符號的語言**",
        "combineTranslation":
            "啟用後，若同一句文字被 HTML 標籤拆開，會先合併後再翻譯，並在翻譯結果上重新套用「修改顯示」腳本。\n這有助於翻譯器產生正確譯文。\n若啟用後 UI 顯示異常，請關閉此選項並回報問題",
        "dynamicAssets":
            "啟用後，處理資料時若找不到完全相同的資源名稱，會透過向量搜尋尋找最接近的名稱並自動替換",
        "dynamicAssetsEditDisplay": "啟用後，動態資源也會套用至「修改顯示」階段，但可能造成效能問題",
        "nickname": "若設定暱稱，對話中的 {{char}} 或 <char> 會使用暱稱取代角色名稱",
        "useRegexLorebook": "啟用後，Lorebook 搜尋會使用 Regex，而非字串比對。格式為 /regex/flags",
        "customChainOfThought": "警告：已不建議使用 Chain of Thought 開關。請改將 Chain of Thought 提示詞放入其他提示詞欄位",
        "customPromptTemplateToggle":
            "可在此自訂提示詞開關。格式為 `<toggle variable>=<toggle name>`，每行一組，例如 `cot=Toggle COT`。可在提示詞中以 `{{getglobalvar::toggle_<toggle variable>}}` 取得開關值，例如 `{{getglobalvar::toggle_cot}}`",
        "defaultVariables":
            "可在此定義預設變數。格式為 `<variable name>=<variable value>`，每行一組，例如 `name=Risuai`。之後可在 Trigger 腳本與變數 CBS 中使用，如 `{{getvar::A}}`、`{{setvar::A::B}}` 或 `{{? $A + 1}}`。若提示詞模板與角色的預設變數名稱相同，會優先使用角色的預設變數",
        "lowLevelAccess":
            "啟用後，可使用需要較高運算資源的功能，並允許透過 Trigger V2 或 Lua 呼叫 AI 模型等底層存取功能。除非確實需要，否則請勿啟用",
        "triggerLLMPrompt":
            "要送給模型的提示詞。可使用 `@@role user`、`@@role system`、`@@role assistant` 建立多輪、不同身分的訊息，例如：\n```\n@@role system\nrespond as hello\n@@role assistant\nhello\n@@role user\nhi\n```",
        "legacyTranslation":
            "啟用後使用舊版翻譯方式：在翻譯前先預處理 Markdown 與引號，而非在翻譯後進行後處理",
        "luaHelp":
            "Trigger 腳本可使用 Lua。您可以定義 onInput、onOutput、onStart 函式；onInput 在使用者送出訊息時呼叫，onOutput 在角色送出訊息時呼叫，onStart 在對話開始時呼叫。詳細資訊請參閱說明文件",
        "openAIFlexProcessing":
            "OpenAI Flex 回應可能比一般回應更慢，但價格較低（Batch API 定價）。此開關只套用於官方 OpenAI Chat Completions 請求",
        "claudeCachingExperimental":
            "Claude Caching 是實驗性功能，可降低模型成本，但若沒有使用重新產生也可能增加成本。由於仍屬實驗性功能，可能不穩定，未來行為也可能變更",
        "urllora":
            "可使用模型檔案的直接下載連結。Google Drive 可透過 https://sites.google.com/site/gdocs2direct/ 等網站建立直接連結；也可使用 CivitAI：複製 AIR（例如 `urn:air:flux1:lora:civitai:180891@776656`，或直接使用 `civitai:180891@776656`）後貼上",
        "v2GetAlertSelect": "選項以 |（pipe）字元分隔",
        "v2RegexTest": "Regex 比對成功時回傳 1，未符合則回傳 0",
        "v2Calculate":
            "計算數學運算式，支援基本四則運算（+、-、*、/、%、^）、比較運算子（<、>、<=、>=、=、!=）、邏輯運算子（&&、||、!）、括號優先順序，以及使用 $variableName 格式代入變數。變數會自動轉成數字，無效值預設為 0",
        "namespace":
            "Namespace 是模組的唯一識別名稱，用於避免模組之間發生衝突，也可供預設集與其他模組引用或互動。若不確定該填什麼，請留空",
        "moduleIntergration":
            "可在模組整合區塊填入模組 Namespace 以啟用模組；若要同時啟用多個模組，請以逗號分隔，例如 `module1,module2,module3`。此功能提供給希望依不同預設集切換模組的進階使用者",
        "customCSS": "自訂 CSS 樣式。若設定造成問題，也可按 Ctrl + . 快速停用／啟用",
        "betaMobileGUI": "啟用後，小於 800px 的螢幕會使用 Beta 行動版 GUI。需要重新整理",
        "enableScrollToActiveChar": "啟用後，按下快捷鍵，或按住 Ctrl 拖曳角色時，會捲動至目前啟用的角色；若角色所在資料夾已收合，會自動展開",
        "unrecommended": "此為不建議使用的設定",
        "jsonSchema":
            "若 AI 模型支援 JSON Schema，此處的 JSON Schema 會一併送給模型。\n\n由於 JSON Schema 較難撰寫，Risuai 也允許使用 TypeScript interface 的子集，並在執行時自動轉換。" +
            '例如，若希望模型輸出下列 JSON：\n\n```js\n{\n  "name": "Risuai", // name 必須為 Risuai\n  "age": 1, // age 必須是數字\n  "icon": "slim", // icon 必須為 \'slim\' 或 \'rounded\'\n  "thoughts": ["Good View!", "Lorem"] // thoughts 必須是字串陣列\n}\n```\n\n' +
            "可填入下列 TypeScript interface：\n\n```typescript\ninterface Schema {\n  name: string;\n  age: number;\n  icon: 'slim'|'rounded'\n  thoughts: string[]\n}\n```\n\n" +
            "interface 名稱沒有影響。更多資訊請參閱 TypeScript 說明文件（https://www.typescriptlang.org/docs/handbook/interfaces.html）；支援的 TypeScript 子集如下。" +
            "<details><summary>支援的 TypeScript 子集</summary>\n\n" +
            `支援的型別有 \`boolean\`、\`number\`、\`string\`、\`Array\`。除下列情況外，不支援 unit type、intersection type、union type、optional、literal type 等進階型別：\n
        - 基本型別陣列（例如 \`string[]\`、\`Array<boolean>\`）
        - 字串常值的聯集型別（例如 \`'slim' | 'rounded'\`）。

        每個屬性必須各自占一行；同一行定義多個屬性會產生錯誤。屬性名稱與 interface 名稱只能使用 ASCII 範圍內的拉丁字元。屬性名稱不可包在單引號或雙引號中。不支援 interface 內的巢狀結構；定義屬性的行內也不可出現 \`{\` 或 \`}\`。若需要更進階的型別，請改用 JSON Schema。
        ` +
            "</details>",
        "strictJsonSchema": "啟用後，部分模型會嚴格遵循提供的 JSON Schema；停用時，模型可能忽略 JSON Schema",
        "extractJson":
            '若此欄位不為空，會從回應中擷取指定 JSON 資料。例如，要從 `{"response": {"text": ["hello"]}}` 擷取 `response.text[0]`，可填入 `response.text.0`',
        "translatorNote":
            "可在此為每個角色加入專屬翻譯提示詞。僅在使用 Ax. 模型翻譯時生效。若要套用，請在語言設定中加入 `{{slot::tnote}}`。群組對話不支援此功能",
        "groupInnerFormat":
            "設定群組對話中非發言角色使用的格式。若不為空，會使用此格式取代預設格式；若「群組中非發言角色的身分」為 `assistant`，也會套用至正在發言的角色",
        "groupOtherBotRole": "設定群組對話中非發言角色使用的身分",
        "chatHTML":
            "插入每則對話的 HTML。\n\n可使用 CBS 與特殊標籤：\n- `<risutextbox>`：用來顯示文字的文字框\n- `<risuicon>`：user 或 assistant 的圖示\n- `<risubuttons>`：編輯、翻譯等對話操作按鈕\n- `<risugeninfo>`：生成資訊按鈕",
        "systemContentReplacement": "模型不支援 system 身分時，會先用此格式改寫原本 system 訊息的內容，再以「system 身分替代值」指定的身分送出；`{{slot}}` 代表原始內容",
        "systemRoleReplacement": "若模型不支援 system 身分，會改用此身分送出原本的 system 訊息",
        "summarizationPrompt":
            "摘要時使用的提示詞。留空會使用預設提示詞。也可使用 ChatML 格式，並以 {{slot}} 代表對話資料",
        "translatorPrompt":
            "翻譯時使用的提示詞。留空會使用預設提示詞。也可使用 ChatML 格式，其中 {{slot}} 代表目標語言、{{slot::content}} 代表內容、{{slot::tnote}} 代表翻譯備註",
        "translateBeforeHTMLFormatting":
            "啟用後，會在 Regex 腳本與 HTML 格式處理前先翻譯文字。這可能減少 Token 使用量，但也可能破壞格式",
        "autoTranslateCachedOnly": "與自動翻譯同時啟用時，只會自動翻譯先前已有翻譯快取的訊息",
        "presetChain":
            "此欄位有內容時，每次使用者送出訊息，都會從清單中隨機選取並套用一個預設集。多個預設集請以逗號分隔，例如 `preset1,preset2`",
        "legacyMediaFindings": "啟用後，使用舊版方式搜尋媒體資源，不使用額外搜尋演算法",
        "comfyWorkflow":
            "填入 ComfyUI 的 API Workflow。可在 ComfyUI 按下「Workflow > Export (API)」匯出。Workflow 內容也必須包含 {{risu_prompt}}，Risu 會將它替換為實際提示詞",
        "automaticCachePoint": "若對話結束時不存在快取點，會自動建立快取點",
        "experimentalChatCompressionDesc":
            "將未使用的對話資料壓縮並存到獨立檔案，可大幅減少對話資料大小並改善效能。但此功能仍屬實驗性，可能不穩定，也可能造成備份等功能出現問題",
        "promptInfoInsideChatDesc":
            "啟用後會將提示詞預設集資訊存入對話中繼資料，包括預設集名稱、啟用中的開關與提示詞文字。可能略微增加處理時間與儲存空間用量",
        "autoAdjustSchema": "啟用後，會自動調整 Dynamic Output 使用的 JSON Schema",
        "dynamicMessages": "啟用後，AI 可以連續送出多則訊息，而非一次只送一則",
        "dynamicMemory": "啟用後，AI 會在產生回應時建立記憶筆記。要實際使用此功能，仍需搭配額外提示詞",
        "dynamicResponseTiming": "啟用後，會動態調整回應時機",
        "dynamicRequest": "啟用後，Risuai 會在隨機時間向模型送出請求，不必等待使用者輸入",
        "settingsCloseButtonSize": "調整設定視窗右上角關閉（X）按鈕大小。預設為 24",
        "showTypingEffect": "啟用後，AI 產生回應期間會顯示「正在輸入」指示器",
        "dynamicOutputPrompt": "啟用後，請求中會包含 Schema 資訊",
        "realmDirectOpen": "啟用後，在 RisuRealm 預覽中按一下角色會直接開啟角色描述",
        "openRouterProviderOrder":
            "設定供應商使用順序。會優先使用清單中的第一個供應商；若不可用則依序改用下一個。詳見 https://openrouter.ai/docs/guides/routing/provider-selection#ordering-specific-providers",
        "openRouterProviderOnly":
            "只允許使用清單中的供應商；若全部都不可用，請求會失敗。詳見 https://openrouter.ai/docs/guides/routing/provider-selection#allowing-only-specific-providers",
        "openRouterProviderIgnore":
            "忽略清單中的供應商；若因此沒有任何可用供應商，請求會失敗。詳見 https://openrouter.ai/docs/guides/routing/provider-selection#ignoring-providers",
        "additionalPrompt":
            "啟用 Prompt Preprocess 時，會附加到主要提示詞末尾的文字。預設為「The assistant must act as {{char}}. user is {{user}}.」，用來建立基本角色扮演上下文",
        "hideAllImagesDesc": "隱藏角色圖示、角色圖片資源與 RisuRealm 封面圖片",
        "embedding":
            "Embedding 模型會用於多項功能的相似度搜尋：\n\n" +
            "- **長期記憶**：HypaMemory V2、HypaMemory V3、HanuraiMemory，以及啟用 HypaMemory 的 SupaMemory\n" +
            "- **額外描述**：依上下文比對角色的額外資訊\n" +
            "- **動態資源**：找不到完全相符的資源名稱時，尋找相似名稱\n" +
            "- **Trigger 腳本**：Trigger 腳本中的相似度條件\n" +
            "- **檔案附件**：搜尋 PDF／TXT／XML 附件內容\n" +
            "- **Playground**：在 Playground 測試 Embedding",
        "keepSessionAlive":
            "維持分頁活動狀態，避免工作階段因閒置而失效。可能需要重新整理才會生效。\n\n" +
            "- **透過音訊**：循環播放人耳聽不到的低頻音以維持工作階段。此方式在大多數瀏覽器中相容性最佳，也通常最有效。在 Android 上啟用時會顯示媒體通知，其他音樂 App 也可能會暫停。\n",
        "reSummarizationPrompt":
            "使用批次編輯將多個已選摘要合併成一個摘要時所用的提示詞。留空則使用預設提示詞",
        "hypaV3MemoryTokensRatio":
            "提示詞中分配給長期記憶區塊 {{slot}} 的 Token 額度，占最大上下文長度的比例",
        "hypaV3ExtraSummarizationRatio":
            "控制摘要要持續到多低的 Token 數才停止。設為 0 時，Token 降到最大上下文長度以下就停止；數值越高，會繼續進行更多摘要後才停止",
        "hypaV3MaxChatsPerSummary":
            "建立單一摘要時最多包含的對話訊息數量",
        "hypaV3RecentMemoryRatio":
            "分配給近期記憶的記憶 Token 比例。會從最新建立的摘要開始自動填入，直到分配額度用滿",
        "hypaV3SimilarMemoryRatio":
            "分配給相似記憶的記憶 Token 比例。會依與近期對話的相似度分數由高至低填入摘要，直到分配額度用滿",
        "hypaV3RandomMemoryRatio":
            "從尚未被其他類別選中的摘要中隨機填入",
        "hypaV3PreserveOrphanedMemory":
            "啟用後，來源對話訊息已被刪除的摘要仍會保留；停用時，來源訊息已不存在的摘要會自動移除",
        "hypaV3ProcessRegexScript":
            "啟用後，在 HypaV3 視窗重新產生摘要時，會先對輸入對話訊息套用 Regex 腳本",
        "hypaV3DoNotSummarizeUserMessage":
            "啟用後，HypaV3 建立摘要時會略過使用者訊息；使用者訊息也不會計入每份摘要的最大訊息數",
        "hypaV3EnableSimilarityCorrection":
            "啟用後，會額外使用近期對話摘要作為相似度搜尋的查詢內容。無法與實驗版 HypaMemory V3 搭配使用",
        "hypaV3UseExperimentalImpl":
            "切換至實驗版 HypaMemory V3。會啟用速率限制設定，並改變相似度查詢方式",
        "hypaV3AlwaysToggleOn":
            "啟用後，選擇角色時會自動開啟 HypaMemory",
        "hypaV3SummarizationRequestsPerMinute":
            "摘要時每分鐘最多可送出的 SupaMemory 模型請求數。僅在 SupaMemory 模型設為輔助模型時生效",
        "hypaV3SummarizationMaxConcurrent":
            "摘要時可同時進行的 SupaMemory 模型請求上限。僅在 SupaMemory 模型設為輔助模型時生效",
        "hypaV3EmbeddingRequestsPerMinute":
            "相似度搜尋每分鐘最多可送出的 Embedding 模型請求數",
        "hypaV3EmbeddingMaxConcurrent":
            "相似度搜尋可同時進行的 Embedding 模型請求上限",
        "hypaV3QueryChatCount":
            "用於相似度搜尋的近期對話訊息數量。數值越高，搜尋查詢就會涵蓋更多對話內容",
        "hypaV3SummaryChunkSeparator":
            "用來將摘要切成多個區塊、供相似度搜尋使用的 Regex",
        "coldstorage": "Cold Storage 會自動將舊對話與角色資料移至獨立儲存空間，以減少主要儲存空間大小並改善效能。這可降低資料傳輸時間與流量，並加快載入對話",
    },
    "setup": {
        "chooseProvider": "選擇 AI 供應商",
        "openaikey": "使用 OpenAI API 金鑰（推薦）",
        "openaiProxy": "OpenAI 反向代理",
        "setupmodelself": "其他／自行設定",
        "inputApiKey": "在此輸入 API 金鑰",
        "apiKeyhelp": "可從此處取得 API 金鑰：",
        "setupSelfHelp": "歡迎畫面結束後，可前往「設定」自行完成其餘設定",
        "theme": "選擇主題",
        "themeDescWifulike": "不適合行動裝置",
        "themeDescWifuCut": "適合行動裝置",
        "themeDescClassic": "適合所有裝置",
        "texttheme": "選擇文字顏色",
        "inputName": "最後，請輸入您的暱稱",
        "welcome": "歡迎使用 Risuai！我是 Airisu，會帶您完成 Risuai 的初始設定。首先，我該怎麼稱呼您？",
        "welcome2": "您好，{username}！開始之前，我會先問幾個問題。之後仍可在設定中修改這些選項。\n\n首先請選擇 AI 供應商",
        "openRouterProvider": "OpenRouter 提供大量模型，其中部分未過濾、部分可免費使用，但整體品質未必如 OpenAI",
        "hordeProvider": "Horde 是免費供應商，但回應時間較長、品質也較低",
        "setProviderLater": "還有其他供應商，您可以稍後再到設定中設定。若想之後再處理，請選擇此項",
        "setupOpenAI":
            "若要使用 OpenAI，您需要取得 API 金鑰。\n1. 前往 https://beta.openai.com/ \n2. 登入帳號\n3. 前往 https://beta.openai.com/account/api-keys \n4. 按下「Create New API Key」並自行命名\n5. 複製網站上的金鑰\n6. 回到 Risuai\n7. 貼上金鑰並按下送出按鈕",
        "setupClaude": "若要使用 Claude，您需要先取得 API 金鑰",
        "setupClaudeSteps": [
            "前往此 URL，並使用 Google 帳號登入",
            "填寫您的資訊後按下「Continue」",
            "在 Organization 頁面，只需在第一個欄位填入任意名稱，再按下「Create Account」",
            "按下「Buy Credits」",
            "按下「Complete Setup」",
            "除國家欄位需填入您的國家外，其餘依上方圖片填寫，接著按下「Continue」",
            "加入付款方式後按下「Continue」",
            "完成付款方式設定後，按下「Add Funds」儲值。最低可儲值 5 美元，也可設定自動儲值",
            "儲值完成後回到 Dashboard，按下「Get API Keys」",
            "按下「Create API Key」",
            "依上方圖片填寫後按下「Add」",
            "複製金鑰，貼到這裡後送出",
        ],
        "setupOpenRouter":
            "若要使用 OpenRouter，您需要取得 API 金鑰。\n1. 前往 https://openrouter.ai/keys\n2. 按下「Create Key」\n3. 自行設定金鑰名稱\n4. 複製網站上的金鑰\n5. 回到 Risuai\n6. 貼上金鑰並按下送出按鈕",
        "allDone": "全部完成！請稍候片刻",
        "welcomeTitleName": "我該怎麼稱呼你？",
        "welcomeTitleGuide": "需要我引導你完成設定嗎？",
        "welcomeTitleProvider": "選擇你的 AI 提供者",
        "welcomeTitleApiKey": "貼上你的 API 金鑰",
        "welcomeTitleChatLang": "選擇聊天語言",
        "welcomeTitleMemory": "記憶還是成本？",
        "welcomeTitleDone": "一切就緒！",
        "welcomeChangeLater": "這些設定之後都可以在設定中更改。",
        "welcomeContinue": "繼續",
        "setupLaterMessage": "歡迎，{username}！您想由我帶您完成設定，還是自行設定？",
        "setupMessageOption1": "帶我完成設定",
        "setupMessageOption1Desc": "推薦給新使用者",
        "setupMessageOption2": "我會自行設定",
        "claudeDesc": "Claude 是 Anthropic 開發的 AI 模型，也是 OpenAI 的競爭者。若使用英語以外的語言，通常比 GPT 更有優勢",
        "openAIDesc": "OpenAI GPT 是高品質 AI 模型，但需要付費、有內容限制，且非英語表現相對較弱",
        "chooseChatType": "很好！接著請選擇對話語言模式",
        "chooseChatTypeOption1": "全英文",
        "chooseChatTypeOption1Desc": "AI 會在內部使用英文，並以英文進行輸入與輸出。推薦給英語使用者",
        "chooseChatTypeOption2": "英文處理",
        "chooseChatTypeOption2Desc": "AI 內部會使用英文處理，但輸入／輸出使用您的語言。推薦給非英語使用者",
        "chooseChatTypeOption3": "不指定語言",
        "chooseChatTypeOption3Desc": "AI 內部直接使用您的語言處理，但可能降低品質",
        "chooseCheapOrMemory": "順帶一問，您比較重視記憶能力，還是成本？",
        "chooseCheapOrMemoryOption1": "記憶優先",
        "chooseCheapOrMemoryOption1Desc": "增加 AI 可記住的內容，但成本也會提高",
        "chooseCheapOrMemoryOption2": "成本優先",
        "chooseCheapOrMemoryOption2Desc": "降低記憶量，以節省成本",
        "chooseCheapOrMemoryOption3": "平衡",
        "chooseCheapOrMemoryOption3Desc": "在記憶量與成本之間取得平衡",
        "chooseCheapOrMemoryOption4": "無限制",
        "chooseCheapOrMemoryOption4Desc": "讓 AI 幾乎記住所有內容，但成本會非常高",
        "finally": "最後，您要啟用進階工具嗎？",
        "finallyOption1": "是",
        "finallyOption1Desc": "會啟用進階工具，但 UI 也會更複雜。推薦給進階使用者",
        "finallyOption2": "否",
        "finallyOption2Desc": "會停用進階工具，使 UI 更簡潔。推薦給新使用者",
        "igpPrompt":
            "若 IGP Prompt 有內容，會在主要模型產生回應後，再以情緒模型執行一次 IGP Prompt，並將結果附加在主要模型回應後方",
    },
    "triggerCategories": {
        "Special": "特殊",
        "Control": "控制",
        "Chat": "對話",
        "Low Level": "低階",
        "Alert": "提示",
        "Lorebook V2": "Lorebook V2",
        "String": "字串",
        "Data": "資料",
        "Array": "陣列",
        "Others": "其他",
        "Deprecated": "已棄用",
    },
    "triggerDesc": {
        "v2Header": "標頭",
        "v2HeaderDesc": "標頭",
        "v2If": "如果",
        "v2IfDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2Else": "否則",
        "v2ElseDesc": "否則",
        "v2EndIndent": "結束縮排",
        "v2EndIndentDesc": "結束縮排",
        "v2SetVar": "設定變數",
        "v2SetVarDesc": "設定變數 {{var}} {{operator}} {{value}}",
        "v2Loop": "無限迴圈",
        "v2LoopDesc": "無限迴圈",
        "v2BreakLoop": "跳出迴圈",
        "v2BreakLoopDesc": "跳出迴圈",
        "v2RunTrigger": "執行 Trigger",
        "v2RunTriggerDesc": "執行 Trigger {{target}}",
        "v2ConsoleLog": "主控台輸出",
        "v2ConsoleLogDesc": "將 {{source}} 輸出至主控台",
        "v2StopTrigger": "停止 Trigger",
        "v2StopTriggerDesc": "停止 Trigger",
        "v2CutChat": "截斷對話",
        "v2CutChatDesc": "將對話訊息截取為索引 {{start}} 到 {{end}} 的範圍",
        "v2ModifyChat": "修改對話",
        "v2ModifyChatDesc": "將索引 {{index}} 的訊息內容修改為 {{value}}",
        "v2SystemPrompt": "加入系統提示詞",
        "v2SystemPromptDesc": "在 {{location}} 加入系統提示詞 {{value}}",
        "v2Impersonate": "送出對話",
        "v2ImpersonateDesc": "以 {{role}} 身分送出 {{value}}",
        "v2Command": "執行指令",
        "v2CommandDesc": "以 {{value}} 執行指令",
        "v2SendAIprompt": "送出 AI 提示詞",
        "v2SendAIpromptDesc": "送出 AI 提示詞",
        "v2ImgGen": "圖片生成",
        "v2ImgGenDesc": "以 {{value}} 生成圖片，負面提示詞為 {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "檢查相似度",
        "v2CheckSimilarityDesc": "檢查 {{source}} 與 {{value}} 的相似度 => {{outputVar}}",
        "v2RunLLM": "執行模型",
        "v2RunLLMDesc": "以 {{value}} 向模型送出請求 => {{outputVar}}",
        "v2ShowAlert": "顯示提示",
        "v2ShowAlertDesc": "顯示內容為 {{value}} 的提示",
        "v2ExtractRegex": "Regex 擷取",
        "v2ExtractRegexDesc":
            "使用 Regex {{regexType}} {{regex}} 與旗標 {{flagsType}} {{flags}} 從 {{value}} 擷取文字，並將結果以 {{resultType}} {{result}} 儲存 => {{outputVar}}",
        "v2RegexTest": "Regex 測試",
        "v2RegexTestDesc": "以 Regex {{regex}} 與旗標 {{flags}} 測試 {{value}} => {{outputVar}}",
        "v2GetLastMessage": "取得最後一則訊息",
        "v2GetLastMessageDesc": "取得最後一則訊息 => {{outputVar}}",
        "v2GetMessageAtIndex": "取得指定索引訊息",
        "v2GetMessageAtIndexDesc": "取得索引 {{index}} 的訊息 => {{outputVar}}",
        "v2GetMessageCount": "取得訊息數量",
        "v2GetMessageCountDesc": "取得訊息數量 => {{outputVar}}",
        "v2GetLorebook": "取得 Lorebook",
        "v2GetLorebookDesc": "取得名為 {{target}} 的 Lorebook => {{outputVar}}",
        "v2GetLorebookCount": "取得 Lorebook 數量",
        "v2GetLorebookCountDesc": "取得 Lorebook 數量 => {{outputVar}}",
        "v2GetLorebookEntry": "依索引取得 Lorebook",
        "v2GetLorebookEntryDesc": "取得索引 {{index}} 的 Lorebook => {{outputVar}}",
        "v2SetLorebookActivation": "設定 Lorebook 啟用狀態",
        "v2SetLorebookActivationDesc": "將索引 {{index}} 的 Lorebook 啟用狀態設為 {{value}}",
        "v2GetLorebookIndexViaName": "依名稱取得 Lorebook 索引",
        "v2GetLorebookIndexViaNameDesc": "依名稱 {{name}} 取得 Lorebook 索引 => {{outputVar}}",
        "v2ModifyLorebook": "修改 Lorebook",
        "v2ModifyLorebookDesc": "以 {{value}} 修改名為 {{target}} 的 Lorebook",
        "v2LoopNTimes": "迴圈 N 次",
        "v2LoopNTimesDesc": "迴圈 {{value}} 次",
        "v2Random": "隨機數",
        "v2RandomDesc": "從 {{min}} 到 {{max}} 隨機取值 => {{outputVar}}",
        "v2GetCharAt": "取得指定索引字元",
        "v2GetCharAtDesc": "取得 {{source}} 中索引 {{index}} 的字元 => {{outputVar}}",
        "v2GetCharCount": "取得字元數量",
        "v2GetCharCountDesc": "取得 {{source}} 的字元數量 => {{outputVar}}",
        "v2ToLowerCase": "轉為小寫",
        "v2ToLowerCaseDesc": "將 {{source}} 轉為小寫 => {{outputVar}}",
        "v2ToUpperCase": "轉為大寫",
        "v2ToUpperCaseDesc": "將 {{source}} 轉為大寫 => {{outputVar}}",
        "v2SetCharAt": "設定指定索引字元",
        "v2SetCharAtDesc": "將 {{source}} 中索引 {{index}} 的字元設為 {{value}} => {{outputVar}}",
        "v2SplitString": "分割字串",
        "v2SplitStringDesc": "以 {{delimiter}} 分割 {{source}} => {{outputVar}}",
        "v2GetCharacterDesc": "取得角色描述",
        "v2GetCharacterDescDesc": "取得角色描述 => {{outputVar}}",
        "v2SetCharacterDesc": "設定角色描述",
        "v2SetCharacterDescDesc": "將角色描述設為 {{value}}",
        "v2GetPersonaDesc": "取得使用者人設",
        "v2GetPersonaDescDesc": "取得使用者人設 => {{outputVar}}",
        "v2SetPersonaDesc": "設定使用者人設",
        "v2SetPersonaDescDesc": "將使用者人設設為 {{value}}",
        "v2GetReplaceGlobalNote": "取得全域備註替換",
        "v2GetReplaceGlobalNoteDesc": "取得全域備註替換 => {{outputVar}}",
        "v2SetReplaceGlobalNote": "設定全域備註替換",
        "v2SetReplaceGlobalNoteDesc": "將全域備註替換設為 {{value}}",
        "v2GetAuthorNote": "取得作者備註",
        "v2GetAuthorNoteDesc": "取得作者備註 => {{outputVar}}",
        "v2SetAuthorNote": "設定作者備註",
        "v2SetAuthorNoteDesc": "將作者備註設為 {{value}}",
        "v2Comment": "加入註解",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "宣告區域變數",
        "v2DeclareLocalVarDesc": "宣告區域變數 {{var}}，值為 {{value}}",
        "v2MakeArrayVar": "建立陣列變數",
        "v2MakeArrayVarDesc": "建立陣列變數 {{var}}",
        "v2GetArrayVarLength": "取得陣列變數長度",
        "v2GetArrayVarLengthDesc": "取得陣列變數 {{var}} 的長度 => {{outputVar}}",
        "v2GetArrayVar": "取得陣列變數",
        "v2GetArrayVarDesc": "取得陣列變數 {{var}} 中索引 {{index}} 的值 => {{outputVar}}",
        "v2SetArrayVar": "設定陣列變數",
        "v2SetArrayVarDesc": "將陣列變數 {{var}} 中索引 {{index}} 的值設為 {{value}}",
        "v2PushArrayVar": "加入陣列變數",
        "v2PushArrayVarDesc": "將 {{value}} 加入陣列變數 {{var}}",
        "v2PopArrayVar": "移除並取得陣列最後一個值",
        "v2PopArrayVarDesc": "移除陣列變數 {{var}} 的最後一個值 => {{outputVar}}",
        "v2ShiftArrayVar": "移除並取得陣列第一個值",
        "v2ShiftArrayVarDesc": "移除陣列變數 {{var}} 的第一個值 => {{outputVar}}",
        "v2UnshiftArrayVar": "將值加入陣列開頭",
        "v2UnshiftArrayVarDesc": "將 {{value}} 加到陣列變數 {{var}} 的第一個位置",
        "v2SpliceArrayVar": "在陣列指定位置插入值",
        "v2SpliceArrayVarDesc": "將 {{value}} 插入陣列變數 {{var}} 的索引 {{start}}",
        "v2SliceArrayVar": "擷取陣列片段",
        "v2SliceArrayVarDesc": "擷取陣列變數 {{var}} 從 {{start}} 到 {{end}} 的片段 => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "取得陣列中指定值的索引",
        "v2GetIndexOfValueInArrayVarDesc": "取得陣列變數 {{var}} 中 {{value}} 的索引 => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "移除陣列指定索引",
        "v2RemoveIndexFromArrayVarDesc": "移除陣列變數 {{var}} 中索引 {{index}} 的值",
        "v2JoinArrayVar": "將陣列串接為字串",
        "v2JoinArrayVarDesc": "以 {{delimiter}} 串接陣列 {{var}} 的元素 => {{outputVar}}",
        "v2MakeDictVar": "建立字典變數",
        "v2MakeDictVarDesc": "建立字典變數 {{var}}",
        "v2GetDictVar": "取得字典值",
        "v2GetDictVarDesc": "取得字典 {{var}} 中鍵 {{key}} 的值 => {{outputVar}}",
        "v2SetDictVar": "設定字典值",
        "v2SetDictVarDesc": "將字典 {{var}} 中鍵 {{key}} 的值設為 {{value}}",
        "v2DeleteDictKey": "刪除字典鍵",
        "v2DeleteDictKeyDesc": "從字典 {{var}} 刪除鍵 {{key}}",
        "v2HasDictKey": "檢查字典鍵",
        "v2HasDictKeyDesc": "檢查字典 {{var}} 是否包含鍵 {{key}} => {{outputVar}}",
        "v2ClearDict": "清空字典",
        "v2ClearDictDesc": "清空字典 {{var}}",
        "v2GetDictSize": "取得字典項目數",
        "v2GetDictSizeDesc": "取得字典 {{var}} 的項目數 => {{outputVar}}",
        "v2GetDictKeys": "取得字典所有鍵",
        "v2GetDictKeysDesc": "取得字典 {{var}} 的所有鍵 => {{outputVar}}",
        "v2GetDictValues": "取得字典所有值",
        "v2GetDictValuesDesc": "取得字典 {{var}} 的所有值 => {{outputVar}}",
        "v2ConcatString": "串接字串",
        "v2ConcatStringDesc": "串接 {{source1}} 與 {{source2}} => {{outputVar}}",
        "v2GetLastUserMessage": "取得最後一則使用者訊息",
        "v2GetLastUserMessageDesc": "取得最後一則使用者訊息 => {{outputVar}}",
        "v2GetLastCharMessage": "取得最後一則角色訊息",
        "v2GetLastCharMessageDesc": "取得最後一則角色訊息 => {{outputVar}}",
        "v2GetFirstMessage": "取得第一則訊息",
        "v2GetFirstMessageDesc": "取得第一則訊息 => {{outputVar}}",
        "v2GetAlertInput": "取得提示視窗輸入值",
        "v2GetAlertInputDesc": "顯示輸入提示視窗並將結果儲存至 {{outputVar}}",
        "v2GetAlertSelect": "取得提示視窗選取結果",
        "v2GetAlertSelectDesc": "顯示 {{display}}，提供選項 {{value}}，並將選取結果儲存至 {{outputVar}}",
        "v2UnsupportedTrigger": "不支援的 Trigger",
        "v2UnsupportedTriggerDesc": "不支援的 Trigger",
        "v2GetDisplayState": "取得顯示狀態",
        "v2GetDisplayStateDesc": "取得顯示狀態 => {{outputVar}}",
        "v2SetDisplayState": "設定顯示狀態",
        "v2SetDisplayStateDesc": "將顯示狀態設為 {{value}}",
        "v2UpdateGUI": "更新 GUI",
        "v2UpdateGUIDesc": "更新 GUI",
        "v2UpdateChatAt": "更新指定索引對話",
        "v2UpdateChatAtDesc": "重新繪製索引 {{index}} 的對話",
        "v2Wait": "等待",
        "v2WaitDesc": "等待 {{value}} 秒",
        "v2GetRequestState": "取得請求資料內容",
        "v2GetRequestStateDesc": "取得索引 {{index}} 的請求內容 => {{outputVar}}",
        "v2SetRequestState": "設定請求資料內容",
        "v2SetRequestStateDesc": "將索引 {{index}} 的請求內容設為 {{value}}",
        "v2GetRequestStateRole": "取得請求資料身分",
        "v2GetRequestStateRoleDesc": "取得索引 {{index}} 的請求資料身分 => {{outputVar}}",
        "v2SetRequestStateRole": "設定請求資料身分",
        "v2SetRequestStateRoleDesc": "將索引 {{index}} 的請求資料身分設為 {{value}}",
        "v2GetRequestStateLength": "取得請求資料長度",
        "v2GetRequestStateLengthDesc": "取得請求資料長度 => {{outputVar}}",
        "v2IfAdvanced": "如果",
        "v2IfAdvancedDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "快速搜尋對話",
        "v2QuickSearchChatDesc": "以 {{condition}} 條件在深度 {{depth}} 的對話中快速搜尋 {{value}} => {{outputVar}}",
        "v2StopPromptSending": "停止送出提示詞",
        "v2StopPromptSendingDesc": "停止送出提示詞",
        "v2Tokenize": "計算 Token 數",
        "v2TokenizeDesc": "計算 {{value}} 的 Token 數 => {{outputVar}}",
        "v2GetAllLorebooks": "取得所有 Lorebook",
        "v2GetAllLorebooksDesc": "取得所有 Lorebook 提示詞並組成陣列 => {{outputVar}}",
        "v2GetLorebookByName": "依名稱取得 Lorebook 索引",
        "v2GetLorebookByNameDesc": "依名稱 {{name}} 取得 Lorebook 索引陣列 => {{outputVar}}",
        "v2GetLorebookByIndex": "取得 Lorebook",
        "v2GetLorebookByIndexDesc": "取得索引 {{index}} 的 Lorebook 提示詞 => {{outputVar}}",
        "v2CreateLorebook": "建立 Lorebook",
        "v2CreateLorebookDesc": "建立 Lorebook：名稱 {{name}}、啟用關鍵字 {{key}}、內容 {{content}}",
        "v2ModifyLorebookByIndex": "修改 Lorebook",
        "v2ModifyLorebookByIndexDesc": "修改索引 {{index}} 的 Lorebook：名稱 {{name}}、啟用關鍵字 {{key}}、內容 {{content}}",
        "v2DeleteLorebookByIndex": "刪除 Lorebook",
        "v2DeleteLorebookByIndexDesc": "刪除索引 {{index}} 的 Lorebook",
        "v2GetLorebookCountNew": "取得 Lorebook 數量",
        "v2GetLorebookCountNewDesc": "取得 Lorebook 總數 => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "設定 Lorebook 一律啟用",
        "v2SetLorebookAlwaysActiveDesc": "將索引 {{index}} 的 Lorebook「一律啟用」設為 {{value}}",
        "v2Calculate": "計算",
        "v2CalculateDesc": "計算 {{expression}} => {{outputVar}}",
        "v2ReplaceString": "替換字串",
        "v2ReplaceStringDesc": "以 Regex {{regex}} 將 {{source}} 替換為 {{replacement}} => {{outputVar}}",
    },
    "triggerInputLabels": {
        "value": "值",
        "var": "變數",
        "varName": "變數名稱",
        "outputVar": "輸出變數",
        "name": "名稱",
        "index": "索引",
        "source": "來源",
        "target": "目標",
        "condition": "條件",
        "operator": "運算子",
        "role": "身分",
        "location": "位置",
        "prompt": "提示詞",
        "model": "模型",
        "start": "開始",
        "end": "結束",
        "min": "最小值",
        "max": "最大值",
        "delimiter": "分隔符號",
        "depth": "深度",
        "key": "鍵",
        "alertContent": "提示內容",
        "options": "選項",
        "cmd": "指令",
        "regex": "Regex",
        "replacement": "替換內容",
        "flags": "旗標",
        "negPrompt": "負面提示詞",
        "resultFormat": "結果格式",
        "activationKeys": "啟用關鍵字",
        "insertOrder": "插入順序",
        "sysStart": "系統開始",
        "sysHistoryEnd": "系統歷史結束",
        "sysPromptEnd": "系統提示詞結束",
        "addElse": "加入 Else",
        "alwaysActive": "一律啟用",
        "trigger": "Trigger",
        "triggerOn": "Trigger 時機",
        "valueTypeDesc": "直接使用輸入值",
        "varTypeDesc": "使用變數中儲存的值",
        "conditionEqual": "等於 (=)",
        "conditionNotEqual": "不等於 (≠)",
        "conditionGreater": "大於 (>)",
        "conditionLess": "小於 (<)",
        "conditionGreaterEqual": "大於等於 (≥)",
        "conditionLessEqual": "小於等於 (≤)",
        "conditionSimilar": "相似 (≒)",
        "conditionContains": "包含 (∋)",
        "conditionIn": "屬於 (∈)",
        "conditionNotContains": "不包含 (∌)",
        "conditionNotIn": "不屬於 (∉)",
        "conditionTruthy": "Truthy (≡)",
        "operatorSet": "設定 (=)",
        "operatorAdd": "加上 (+=)",
        "operatorSubtract": "減去 (-=)",
        "operatorMultiply": "乘上 (*=)",
        "operatorDivide": "除以 (/=)",
        "operatorModulo": "取餘數 (%=)",
        "searchLoose": "寬鬆搜尋",
        "searchStrict": "嚴格搜尋",
        "searchRegex": "Regex 搜尋",
        "modelMain": "主要模型",
        "modelSub": "輔助模型",
        "roleUser": "user",
        "roleChar": "char",
        "roleSystem": "system",
        "roleAssistant": "assistant",
        "boolTrue": "True",
        "boolFalse": "False",
        "boolNull": "Null",
        "helpVarName": "輸入變數名稱",
        "helpOutputVar": "輸入用來儲存結果的變數名稱",
        "helpIndex": "陣列或訊息索引編號",
        "helpRegex": "輸入 Regex",
        "helpFlags": "Regex 旗標",
        "helpDelimiter": "分割字串時使用的分隔符號",
        "helpActivationKeys": "以逗號分隔的啟用關鍵字",
        "helpInsertOrder": "插入順序",
        "helpDepth": "搜尋訊息的深度",
        "helpMinMax": "最小值與最大值範圍",
        "helpSlot": "使用 {{slot}} 保持原值不變",
        "expression": "運算式",
    },
    "playground": {
        "playground": "Playground",
        "inlayDeleteSelected": "刪除已選項目",
        "inlayDeselectAll": "取消所有選取",
        "inlayEmpty": "沒有已儲存的內嵌資源",
        "inlayEmptyDesc": "對話中附加或生成的圖片、音訊與影片會顯示在這裡",
        "inlayExplorer": "內嵌資源瀏覽器",
        "inlaySelectAll": "全部選取",
        "inlayDeleteConfirm": "確定要刪除 {name} 嗎？",
        "inlayDeleteMultipleConfirm": "確定要刪除已選取的 {count} 個資源嗎？",
        "inlayTotalAssets": "共 {count} 個資源",
    },
    "confirm": "確認",
    "goback": "返回",
    "botSettings": "Bot 設定",
    "model": "模型",
    "apiKey": "API 金鑰",
    "providerURL": "請求 URL",
    "providerJSON": "Request Body（JSON）",
    "mainPrompt": "主要提示詞",
    "jailbreakPrompt": "越獄提示詞",
    "globalNote": "全域備註",
    "autoSuggest": "自動建議",
    "tokens": "Token",
    "maxContextSize": "最大上下文長度",
    "maxResponseSize": "最大回應長度",
    "temperature": "Temperature",
    "frequencyPenalty": "Frequency Penalty",
    "presensePenalty": "Presence Penalty",
    "advancedSettings": "進階設定",
    "advancedSettingsWarn": "警告：若您不知道某個選項的用途，請勿修改！",
    "formatingOrder": "提示詞排列順序",
    "authorNote": "作者備註",
    "firstMessage": "開局訊息",
    "description": "描述",
    "note": "備註",
    "jailbreakToggle": "越獄開關",
    "charIcon": "角色圖示",
    "characterDisplay": "角色顯示",
    "viewScreen": "角色畫面",
    "none": "無",
    "emotionImage": "情緒立繪",
    "noImages": "沒有圖片",
    "noBias": "未設定 Bias",
    "image": "圖片",
    "name": "名稱",
    "folderName": "資料夾名稱",
    "folderRemoveConfirm": "此資料夾包含 Lorebook。確定要刪除此資料夾及其中所有內容嗎？",
    "emotion": "情緒名稱",
    "value": "值",
    "reroll": "重新產生",
    "chatList": "對話清單",
    "removeChat": "要移除此訊息嗎？",
    "loreBook": "Lorebook",
    "character": "角色",
    "Chat": "對話",
    "globalLoreInfo": "角色 Lorebook 會套用至此角色的所有對話",
    "group": "群組",
    "groupLoreInfo": "群組 Lorebook 會套用至此群組的所有對話",
    "localLoreInfo": "對話 Lorebook 只套用至目前對話",
    "removeConfirm": "確定要移除：",
    "removeConfirm2": "真的確定要移除：",
    "exportConfirm": "要匯出此項目嗎？",
    "insertOrder": "插入順序",
    "activationKeys": "啟用關鍵字",
    "activationKeysInfo": "以逗號分隔",
    "prompt": "提示詞",
    "loreBookDepth": "Lorebook 搜尋深度",
    "loreBookToken": "Lorebook 最大 Token",
    "chatLoadInitialPages": "初始對話載入數量",
    "chatLoadAdditionalPages": "額外對話載入數量",
    "removeCharacter": "移除角色",
    "removeGroup": "移除群組",
    "exportCharacter": "匯出角色",
    "userSetting": "使用者設定",
    "username": "您的名字",
    "userIcon": "您的圖示",
    "successExport": "匯出成功，檔案已下載至您的下載資料夾",
    "successImport": "匯入成功",
    "importedCharacter": "已匯入角色",
    "alwaysActive": "一律啟用",
    "additionalPrompt": "額外提示詞",
    "descriptionPrefix": "描述前綴",
    "forceReplaceUrl": "反向代理",
    "emotionWarn": "會使用輔助模型",
    "plugin": "外掛",
    "language": "語言",
    "UiLanguage": "UI 語言",
    "createfromScratch": "從空白建立",
    "importCharacter": "匯入角色",
    "translator": "翻譯器",
    "disabled": "已停用",
    "noPluginSelected": "已選擇外掛模型，但尚未選擇外掛",
    "text": "文字",
    "UISize": "對話文字大小",
    "newVersion": "發現更新，要立即安裝嗎？",
    "remindLaterQuestion": "要在什麼時候再次提醒？",
    "remindIgnore": "忽略",
    "remindLater1Day": "1 天後提醒",
    "remindLater3Days": "3 天後提醒",
    "remindLater5Days": "5 天後提醒",
    "remindLater1Week": "1 週後提醒",
    "display": "顯示與音訊",
    "useCustomBackground": "自訂背景",
    "translateInput": "翻譯輸入",
    "autoTranslation": "自動翻譯",
    "fullscreen": "全螢幕",
    "playMessage": "播放訊息音訊",
    "iconSize": "圖示大小",
    "createGroup": "建立群組對話",
    "groupIcon": "群組圖示",
    "single": "單一",
    "multiple": "多個",
    "useCharLorebook": "使用角色 Lorebook",
    "selectChar": "選擇角色",
    "askLoadFirstMsg": "要載入開局訊息嗎？",
    "theme": "主題",
    "editOrder": "編輯順序",
    "autoMode": "自動模式",
    "submodel": "輔助模型",
    "timeOutinSec": "逾時（秒）",
    "emotionPrompt": "情緒提示詞",
    "singleView": "單角色檢視",
    "SpacedView": "多角色檢視",
    "emphasizedView": "雙角色檢視",
    "pluginWarn": "安裝惡意外掛可能造成安全問題",
    "pluginConfirm": "確定要匯入此外掛嗎？請只匯入來自可信來源的外掛",
    "pluginContainsExternalMedia": "此外掛包含外部媒體",
    "pluginContainsExternalJS": "此外掛包含外部 JavaScript",
    "createGroupImg": "產生群組圖示",
    "waifuWidth": "Waifu 對話寬度",
    "savebackup": "將備份儲存至 Google Drive",
    "loadbackup": "從 Google Drive 載入備份",
    "files": "檔案",
    "backupConfirm": "確定要儲存備份嗎？",
    "backupLoadConfirm": "確定要載入備份嗎？目前資料將由備份內容覆寫！",
    "backupLoadConfirm2": "再次確認：真的要載入備份嗎？目前資料將由備份內容覆寫！",
    "pasteAuthCode": "請複製彈出視窗中的驗證碼，並貼到這裡：",
    "others": "其他",
    "presets": "預設集",
    "imageGeneration": "圖片生成",
    "provider": "供應商",
    "key": "金鑰",
    "noData": "沒有資料",
    "currentImageGeneration": "目前圖片生成資料",
    "promptPreprocess": "啟用提示詞預處理（Prompt Preprocess）",
    "SwipeRegenerate": "使用滑動重新產生",
    "instantRemove": "移除訊息時一併移除後續訊息",
    "instantRemoveConfirm": "只要移除這一則訊息嗎？若選擇「否」，其後訊息也會一併移除",
    "textColor": "文字顏色",
    "classicRisu": "Classic Risu",
    "highcontrast": "高對比",
    "quickPreset": "可按 Ctrl +（預設集編號）快速切換預設集",
    "requestretrys": "請求失敗時的重試次數",
    "utilityBot": "工具型 Bot",
    "ShowLog": "顯示請求記錄",
    "waifuWidth2": "Waifu 角色大小",
    "sayNothing": "沒有輸入文字時送出「say nothing」",
    "regexScript": "Regex 腳本",
    "type": "類型",
    "editInput": "修改輸入",
    "editOutput": "修改輸出",
    "editProcess": "修改請求資料",
    "loadLatest": "載入最新備份",
    "loadOthers": "載入其他備份",
    "exampleMessage": "示範對話",
    "creatorNotes": "創作者留言",
    "systemPrompt": "系統提示詞",
    "characterNotes": "角色備註",
    "personality": "性格",
    "scenario": "情境",
    "alternateGreetings": "替代開局訊息",
    "unrecommended": "不建議使用",
    "chatNotes": "對話備註",
    "showUnrecommended": "顯示不建議使用的設定",
    "streamingDisplayOptimizationMode": "串流顯示最佳化",
    "streamingDisplayOptimizationOff": "關閉",
    "streamingDisplayOptimizationBalanced": "平衡",
    "streamingDisplayOptimizationStrong": "強力",
    "altGreet": "替代開局訊息",
    "scripts": "腳本",
    "settings": "設定",
    "selective": "選擇性",
    "SecondaryKeys": "次要關鍵字",
    "useGlobalSettings": "使用全域設定",
    "recursiveScanning": "遞迴掃描",
    "creator": "創作者",
    "CharVersion": "角色版本",
    "Speech": "語音",
    "ToggleSuperMemory": "切換 SupaMemory",
    "SuperMemory": "SupaMemory",
    "useExperimental": "啟用實驗性功能",
    "showMemoryLimit": "顯示記憶上限",
    "showFirstMessagePages": "顯示開局訊息分頁",
    "roundIcons": "圓形圖示",
    "streaming": "串流",
    "chatBot": "聊天 Bot",
    "otherBots": "其他 Bot",
    "user": "使用者",
    "additionalAssets": "額外資源",
    "editDisplay": "修改顯示",
    "community": "社群",
    "textBackgrounds": "自訂文字區域顏色",
    "textBorder": "文字外框",
    "textScreenRound": "圓角文字區域",
    "textScreenBorder": "文字區域邊框",
    "ttsReadOnlyQuoted": "只朗讀引號內容",
    "ttsStop": "停止 TTS",
    "askRemoval": "移除前詢問",
    "replaceGlobalNote": "全域備註替換",
    "charLoreBook": "角色 Lorebook",
    "globalLoreBook": "全域 Lorebook",
    "globalRegexScript": "全域 Regex",
    "accessibility": "無障礙",
    "sendWithEnter": "使用 Enter 鍵送出",
    "fixedChatTextarea": "固定在對話視窗底部（取消勾選後，Shift + Enter 將改為送出訊息。）",
    "clickToEdit": "按一下文字以編輯",
    "enableBlockPartialEdit": "啟用區塊局部編輯（滑鼠移至個別區塊即可編輯）",
    "enableDragPartialEdit": "啟用拖曳局部編輯（選取文字即可編輯）",
    "setNodePassword": "設定密碼以提升安全性",
    "inputNodePassword": "輸入您的密碼。若忘記密碼，請刪除伺服器檔案中的 save/__password.txt 後重新啟動伺服器",
    "simple": "簡易",
    "advanced": "進階",
    "askReRollAutoSuggestions": "重新產生自動建議",
    "creatingSuggestions": "正在產生建議...",
    "orderByOrder": "依順序發言",
    "removeFromGroup": "確定要將 {{char}} 從群組中移除嗎？",
    "talkness": "發言頻率",
    "active": "啟用",
    "loreRandomActivation": "使用機率條件",
    "activationProbability": "機率",
    "shareCloud": "分享至 RisuRealm",
    "hub": "RisuRealm",
    "tags": "標籤",
    "backgroundHTML": "對話背景 HTML",
    "copied": "已複製",
    "useChatCopy": "啟用對話訊息複製",
    "useChatSticker": "使用對話貼圖",
    "useAdditionalAssetsPreview": "使用額外資源預覽",
    "autoTranslateInput": "自動翻譯輸入",
    "enterMessageForTranslateToEnglish": "輸入要翻譯成英文的訊息",
    "recent": "最近",
    "downloads": "下載",
    "trending": "熱門",
    "imageCompression": "圖片壓縮",
    "notLoggedIn": "尚未登入 Risu 帳號",
    "googleDriveInfo": "連接 Google Drive 以同步您的資料",
    "googleDriveConnection": "Google Drive 連線",
    "googleDriveConnected": "Google Drive 已連線",
    "SaveDataInAccount": "將資料儲存至帳號",
    "dataSavingInAccount": "正在將資料儲存至帳號",
    "logout": "登出",
    "loadDataFromAccount": "從帳號載入資料",
    "saveCurrentDataToAccount": "將目前資料儲存至帳號",
    "chatAssumed": "",
    "proxyAPIKey": "金鑰／密碼",
    "proxyRequestModel": "請求模型",
    "officialWiki": "官方 Wiki",
    "officialWikiDesc": "查看 Risuai 官方 Wiki",
    "officialDiscord": "官方 Discord",
    "officialDiscordDesc": "Risuai 官方 Discord 社群",
    "persona": "使用者人設",
    "icon": "圖示",
    "account": "帳號",
    "remove": "移除",
    "able": "啟用",
    "assetWidth": "資源圖片最大寬度",
    "animationSpeed": "動畫速度",
    "screenshot": "螢幕截圖",
    "screenshotSaved": "螢幕截圖已儲存",
    "createBotwithAI": "使用 AI 建立角色",
    "changeFolderName": "輸入新的資料夾名稱（留空則取消）",
    "cancel": "取消",
    "renameFolder": "重新命名資料夾",
    "changeFolderColor": "變更資料夾顏色",
    "changeFolderImage": "變更資料夾圖片",
    "fullWordMatching": "完整單字比對",
    "botSettingAtStart": "啟動時開啟 Bot 設定",
    "triggerStart": "送出對話時",
    "triggerInput": "使用者送出訊息時",
    "triggerOutput": "角色回應時",
    "triggerManual": "僅手動觸發",
    "triggerCondVar": "若變數符合",
    "triggerCondExists": "若對話中存在文字",
    "triggerScript": "Trigger 腳本",
    "triggerMatchRegex": "使用 Regex 比對",
    "triggerMatchLoose": "寬鬆比對",
    "triggerMatchStrict": "嚴格比對",
    "searchDepth": "搜尋深度",
    "equal": "等於",
    "notEqual": "不等於",
    "greater": "大於",
    "less": "小於",
    "greaterEqual": "大於等於",
    "lessEqual": "小於等於",
    "triggerEffSysPrompt": "加入系統提示詞",
    "triggerEffSetVar": "修改變數",
    "triggerEffImperson": "送出對話",
    "triggerEffCommand": "執行指令",
    "triggerEffRunTrigger": "執行 Trigger",
    "triggerEffStop": "停止送出提示詞",
    "triggerEffCall": "呼叫 Trigger",
    "varableName": "變數名稱",
    "role": "身分",
    "location": "位置",
    "promptstart": "提示詞開頭",
    "promptend": "提示詞結尾",
    "historyend": "歷史紀錄結尾",
    "always": "一律",
    "noEffect": "無作用",
    "invaildTriggerEffect": "此效果不適用於目前的 Trigger 類型",
    "operator": "運算子",
    "TriggerSetToVar": "設定變數",
    "TriggerAddToVar": "變數加上",
    "TriggerSubToVar": "變數減去",
    "TriggerMulToVar": "變數乘以",
    "TriggerDivToVar": "變數除以",
    "isNull": "未設定",
    "ifChatIndex": "對話索引",
    "ifRandom": "隨機值",
    "ifValue": "指定值",
    "hideRealm": "隱藏 RisuRealm",
    "blockRealmCreator": "封鎖創作者",
    "blockRealmCreatorConfirm": "要封鎖 {{creator}} 在 RisuRealm 上的所有內容嗎？",
    "realmCreatorBlocked": "此內容來自已封鎖的 RisuRealm 創作者，無法使用。",
    "realmCreatorBlockedSuccess": "已封鎖創作者。",
    "manageBlockedRealmCreators": "管理已封鎖的創作者",
    "blockedRealmCreators": "已封鎖的 RisuRealm 創作者",
    "noBlockedRealmCreators": "沒有已封鎖的 RisuRealm 創作者。",
    "unblockRealmCreator": "解除封鎖",
    "hideAllImages": "隱藏所有圖片",
    "popularityLevel": "{} 人氣",
    "colorScheme": "配色方案",
    "rangeStart": "範圍開始",
    "rangeEnd": "範圍結束",
    "untilChatEnd": "直到對話結束",
    "usePromptTemplate": "使用提示詞模板",
    "specialType": "特殊類型",
    "noSpecialType": "無特殊類型",
    "forceProxyAsOpenAI": "強制代理使用 OpenAI 格式",
    "promptTemplate": "提示詞模板",
    "customInnerFormat": "自訂內部格式",
    "innerFormat": "內部格式",
    "HypaMemory": "HypaMemory",
    "ToggleHypaMemory": "切換 HypaMemory",
    "resetPromptTemplateConfirm": "確定要重設提示詞模板嗎？",
    "emotionMethod": "情緒處理方式",
    "continueResponse": "繼續回應",
    "showMenuChatList": "在選單顯示對話清單",
    "translatorLanguage": "翻譯語言",
    "translatorType": "翻譯器類型",
    "htmlTranslation": "HTML 翻譯",
    "deeplKey": "DeepL API 金鑰",
    "deeplFreeKey": "DeepL Free API 金鑰",
    "deeplXUrl": "DeepLX URL",
    "deeplXToken": "DeepLX Token",
    "exportPersona": "匯出使用者人設",
    "importPersona": "匯入使用者人設",
    "export": "匯出",
    "import": "匯入",
    "supporterThanks": "感謝贊助者",
    "supporterThanksDesc": "感謝您的支持！",
    "donatorPatreonDesc": "基於隱私考量，預設不會顯示於清單中。若希望顯示您的暱稱，請前往 Risuai 的 Patreon 頁面並按下連結按鈕",
    "useNamePrefix": "使用名稱前綴",
    "textAdventureNAI": "以文字冒險模式執行",
    "appendNameNAI": "在 NAI 中附加名稱",
    "customStopWords": "自訂停止詞",
    "defaultPrompt": "預設提示詞",
    "additionalText": "額外描述",
    "seed": "Seed",
    "charjs": "CharacterJS",
    "depthPrompt": "深度插入提示詞",
    "largePortrait": "直式大圖",
    "lorePlus": "Lorebook+",
    "reverseProxyOobaMode": "Ooba 模式",
    "joinMultiUserRoom": "加入多人房間",
    "exactTokens": "精確 Token 數",
    "fixedTokens": "估算 Token 數",
    "inlayViewScreen": "內嵌畫面",
    "imgGenPrompt": "圖片生成提示詞",
    "imgGenNegatives": "圖片生成負面提示詞",
    "imgGenInstructions": "圖片生成指示",
    "usePlainFetchWarn": "使用 NovelAI 時請停用此選項，否則可能因 NovelAI 產生 CORS 錯誤",
    "translationPrompt": "翻譯提示詞",
    "translationResponseSize": "翻譯回應長度",
    "webdeeplwarn": "不建議在網頁版使用此選項，可能造成 CORS 錯誤",
    "saveBackupLocal": "在本機儲存備份",
    "loadBackupLocal": "從本機載入備份",
    "topP": "Top P",
    "genTimes": "一次產生的回應數",
    "cot": "Chain of Thought",
    "forcePlainFetch": "強制一般 Fetch",
    "autoFillRequestURL": "自動填入請求 URL",
    "newOAIHandle": "新版 OpenAI 處理方式",
    "inlayImage": "內嵌圖片功能",
    "nativeAutomark": "實驗性原生 Automark",
    "assistantPrefill": "assistant 預填",
    "postEndInnerFormat": "尾端附加提示詞",
    "sendChatAsSystem": "以 system 身分送出對話",
    "sendName": "在非群組對話中送出名稱",
    "utilOverride": "工具模式模板覆寫",
    "template": "模板",
    "chatAsOriginalOnSystem": "以原始身分送出",
    "exportAsDataset": "將存檔匯出為資料集",
    "editTranslationDisplay": "編輯翻譯顯示",
    "selectModel": "選擇模型",
    "autoRemoveThoughtTag": "移除 Thought Tag",
    "customChainOfThought": "自訂 Chain of Thought",
    "maxThoughtTagDepth": "Thought Tag 最大深度",
    "openRouterFallback": "使用 Fallback",
    "openRouterMiddleOut": "使用 Middle Out",
    "openRouterProviderOrder": "供應商偏好順序",
    "openRouterProviderOnly": "允許的供應商",
    "openRouterProviderIgnore": "忽略的供應商",
    "openRouterSearchModel": "搜尋模型...",
    "openRouterSortByName": "名稱",
    "openRouterSortByPrice": "價格",
    "openRouterSortByProvider": "供應商",
    "openRouterSortAsc": "升冪",
    "openRouterSortDesc": "降冪",
    "geminiApiKey": "Gemini API 金鑰",
    "removePunctuationHypa": "記憶處理時移除標點",
    "memoryLimitThickness": "記憶上限線條粗細",
    "inputCardPassword": "輸入角色卡密碼",
    "ccv2Desc": "Character Card V2 是聊天機器人程式廣泛使用的格式",
    "ccv3Desc": "Character Card V3 是聊天機器人程式使用的次世代格式",
    "realmDesc": "RisuRealm 是 Risuai 的內容分享平台，可將您的角色分享給其他使用者",
    "rccDesc": "Risu Refined Character Card 是加入密碼、完整性檢查等額外功能的格式",
    "password": "密碼",
    "license": "授權條款",
    "licenseDesc": "可為卡片指定授權條款，限制下載者修改卡片或重新匯出的權限",
    "passwordDesc": "可設定密碼，避免未經授權存取您的角色卡",
    "largePersonaPortrait": "使用者人設大圖",
    "module": "模組",
    "modules": "模組",
    "noModules": "尚未安裝任何模組",
    "createModule": "建立模組",
    "basicInfo": "基本資訊",
    "moduleContent": "模組內容",
    "confirmRemoveModuleFeature": "確定要移除此功能嗎？此操作無法復原",
    "editModule": "編輯模組",
    "importModule": "匯入模組",
    "download": "下載",
    "edit": "編輯",
    "enableGlobal": "全域啟用",
    "chatModulesInfo": "可為目前對話啟用或停用模組。也可以在「啟用」按鈕上按右鍵或長按，改為替目前角色啟用該模組",
    "sideMenuRerollButton": "側邊選單重新產生按鈕",
    "persistentStorage": "持久性儲存",
    "persistentStorageSuccess": "已成功啟用持久性儲存",
    "persistentStorageFail": "無法啟用持久性儲存。可能是您拒絕了權限請求，或瀏覽器不支援此功能",
    "persistentStorageRecommended": "建議啟用持久性儲存",
    "persistentStorageDesc": "您的瀏覽器支援持久性儲存。建議啟用以獲得較佳效能與使用體驗",
    "enable": "啟用",
    "postFile": "附加檔案",
    "requestInfoInsideChat": "在對話中顯示請求資訊",
    "inputTokens": "輸入 Token",
    "outputTokens": "輸出 Token",
    "tokenWarning": "Token 計算可能不準確，建議僅作為參考",
    "log": "記錄",
    "popularityLevelDesc": "人氣會隨下載次數等方式增加",
    "additionalParams": "額外參數",
    "heightMode": "高度模式",
    "useAdvancedEditor": "使用進階編輯器",
    "noWaitForTranslate": "不等待翻譯完成",
    "updateRealm": "更新至 RisuRealm",
    "updateRealmDesc": "您正在嘗試將角色更新至 RisuRealm。此操作會更新 RisuRealm 上的角色，而且無法還原",
    "antiClaudeOverload": "防止 Claude 過載",
    "activeTabChange": "其他分頁目前處於啟用狀態，因此此分頁已停用。若要切換至此分頁，請按「確定」",
    "maxSupaChunkSize": "SupaMemory 最大分段大小",
    "addCharacter": "加入角色",
    "importFromRealm": "從 RisuRealm 選擇",
    "importFromRealmDesc": "可從 RisuRealm 的 1,000 多個角色中選擇",
    "random": "隨機",
    "metaData": "中繼資料",
    "autoContinueMinTokens": "目標 Token（自動繼續）",
    "autoContinueChat": "防止回應未完成（自動繼續）",
    "removeIncompleteResponse": "移除未完成句子",
    "tokenizer": "Tokenizer",
    "chatFormating": "對話格式",
    "useInstructPrompt": "使用 Instruction Prompt",
    "hanuraiMemory": "HanuraiMemory",
    "textAreaSize": "輸入區域大小",
    "textAreaTextSize": "輸入區域文字大小",
    "sideBarSize": "側邊欄大小",
    "embedding": "Embedding",
    "syntax": "語法",
    "run": "執行",
    "noMessage": "輸入訊息以開始對話",
    "combineTranslation": "合併後翻譯",
    "dynamicAssets": "動態資源",
    "dynamicAssetsEditDisplay": "在顯示階段使用動態資源",
    "longTermMemory": "長期記憶",
    "grid": "網格",
    "list": "清單",
    "trash": "垃圾桶",
    "trashDesc": "已刪除角色會移至垃圾桶，可在此還原或永久刪除。垃圾桶中的角色會在 3 天後永久刪除",
    "shareExport": "分享／匯出",
    "risupresetDesc": "Risupreset 是專為 Risuai 預設集設計的格式",
    "risuMDesc": "RisuM 是專為 Risuai 模組設計的格式",
    "jsonDesc": "JSON 是人類與機器都容易閱讀與撰寫的格式",
    "nickname": "暱稱",
    "useRegexLorebook": "使用 Regex",
    "customPromptTemplateToggle": "自訂開關",
    "defaultVariables": "預設變數",
    "hypaAllocatedTokens": "已分配 Token",
    "hypaChunkSize": "分段大小",
    "hypaV2Desc": "HypaMemory V2 是同時使用摘要資料與向量搜尋的長期記憶系統",
    "supaDesc": "SupaMemory 是透過摘要資料提供 AI 長期記憶的系統",
    "hanuraiDesc": "HanuraiMemory 是使用向量搜尋的記憶系統",
    "lowLevelAccess": "低階存取",
    "resultStoredVar": "儲存結果的變數",
    "triggerEffRunLLM": "執行主要模型",
    "triggerEffectSendAI": "重新送出 AI 請求",
    "triggerEffCheckSim": "檢查相似度",
    "triggerEffShowAlert": "顯示提示",
    "normal": "一般",
    "error": "錯誤",
    "input": "輸入",
    "select": "選擇",
    "options": "選項",
    "alertContent": "提示內容",
    "lowLevelAccessConfirm":
        "此內容使用低階存取，代表它能直接存取 AI 模型與您的儲存空間。確定要匯入此內容嗎？",
    "triggerLowLevelOnly": "此 Trigger 只能在啟用低階存取時使用。請在角色或模組的進階設定中啟用低階存取",
    "truthy": "Truthy",
    "extractRegex": "使用 Regex 擷取文字",
    "runImgGen": "執行圖片生成",
    "cutChat": "截斷對話",
    "modifyChat": "修改對話",
    "regex": "Regex",
    "flags": "旗標",
    "resultFormat": "結果格式",
    "negPrompt": "負面提示詞",
    "start": "開始",
    "end": "結束",
    "index": "索引",
    "search": "搜尋",
    "goCharacterOnImport": "從 RisuRealm 匯入後開啟角色",
    "format": "格式",
    "v2Warning": "警告：已不再支援 V2 角色卡，資料可能不完整",
    "applyModule": "套用模組",
    "successApplyModule": "已成功套用模組",
    "font": "字型",
    "lineHeight": "行高",
    "loadAutoServerBackup": "載入伺服器自動備份",
    "notCharxWarn": "此角色使用多個資源。為了獲得較佳相容性，建議以 CharX 格式匯出",
    "noPlugins": "尚未安裝外掛",
    "legacyTranslation": "舊版翻譯",
    "clipboardSuccess": "已複製至剪貼簿",
    "translateContent": "翻譯內容",
    "doNotTranslate": "不要翻譯",
    "includePersonaName": "包含使用者人設名稱",
    "hidePersonaName": "隱藏使用者人設名稱",
    "triggerSwitchWarn": "變更 Trigger 類型後，目前的 Trigger 設定會遺失。確定要繼續嗎？",
    "codeMode": "程式碼",
    "blockMode": "區塊",
    "helpBlock": "說明",
    "hideChatIcon": "隱藏圖示 UI",
    "loadInternalBackup": "載入內部備份",
    "createCopy": "建立副本",
    "bindPersona": "綁定使用者人設",
    "chatOptions": "對話選項",
    "doYouWantToBindCurrentPersona": "要將目前的使用者人設綁定至此對話嗎？",
    "doYouWantToUnbindCurrentPersona": "要解除此對話綁定的使用者人設嗎？",
    "personaBindedSuccess": "已成功綁定使用者人設",
    "personaUnbindedSuccess": "已成功解除使用者人設綁定",
    "parameters": "參數",
    "sizeAndSpeed": "大小與速度",
    "useLegacyGUI": "使用舊版 GUI",
    "claudeCachingExperimental": "Claude 快取",
    "openClose": "開啟／關閉",
    "hideApiKeys": "隱藏 API 金鑰",
    "unformatQuotes": "停用引號格式化",
    "enableDevTools": "啟用開發者工具",
    "selectFile": "選擇檔案",
    "namespace": "Namespace",
    "moduleIntergration": "模組整合",
    "previewInfo": "此預覽顯示套用模型專屬處理前的提示詞",
    "miscTools": "其他工具",
    "promptConvertion": "提示詞轉換",
    "convertionStep1": "選擇所有與提示詞相關的檔案（支援 Context、Instruct 與 Sampler JSON）",
    "customCSS": "自訂 CSS",
    "betaMobileGUI": "Beta 行動版 GUI",
    "enableScrollToActiveChar": "啟用捲動至目前角色",
    "menu": "選單",
    "connectionOpen": "連線已開啟",
    "connectionOpenInfo": "多人房間已開啟。您可以將房間代碼分享給其他使用者；其他人可在 Playground > 加入多人房間中輸入代碼加入",
    "createMultiuserRoom": "建立多人房間",
    "connectionHost": "您是此房間的主持人",
    "connectionGuest": "您是此房間的來賓",
    "otherUserRequesting": "其他使用者正在送出請求，請稍後再試",
    "jsonSchema": "JSON Schema",
    "enableJsonSchema": "啟用 Schema",
    "strictJsonSchema": "嚴格 Schema",
    "extractJson": "擷取 JSON",
    "reloadSession": "發現較新版本的存檔資料，正在重新載入工作階段...",
    "fixMarkdownNewline": "修正 Markdown 換行",
    "customQuotes": "自訂引號",
    "leadingSingleQuote": "開頭單引號",
    "leadingDoubleQuote": "開頭雙引號",
    "trailingSingleQuote": "結尾單引號",
    "trailingDoubleQuote": "結尾雙引號",
    "translatorNote": "翻譯備註",
    "formatGroupInSingle": "非群組對話也顯示角色名稱",
    "groupInnerFormat": "非發言角色的內部格式",
    "groupOtherBotRole": "群組中非發言角色的身分",
    "defineCustomGUI": "定義自訂 GUI",
    "chatHTML": "對話 HTML",
    "logShare": "顯示分享記錄按鈕",
    "preview": "預覽",
    "recommended": "推薦",
    "newChat": "新對話",
    "predictedOutput": "預測輸出",
    "systemContentReplacement": "system 內容替代格式",
    "systemRoleReplacement": "system 身分替代值",
    "seperateParameters": "獨立參數設定",
    "seperateParametersEnabled": "啟用獨立參數設定",
    "summarizationPrompt": "摘要提示詞",
    "reSummarizationPrompt": "重新摘要提示詞",
    "translatorPrompt": "翻譯提示詞",
    "translateBeforeHTMLFormatting": "在 HTML 格式化前翻譯",
    "retranslate": "重新翻譯",
    "editTranslation": "編輯翻譯",
    "editTranslationSave": "儲存翻譯",
    "exportTranslationCache": "匯出翻譯快取",
    "exportTranslationCacheSuccess": "已成功匯出翻譯快取",
    "importTranslationCache": "匯入翻譯快取",
    "importTranslationCacheConfirm": "這會將項目合併至您的翻譯快取，現有同名鍵會被覆寫。確定要繼續嗎？",
    "importTranslationCacheSuccess": "已匯入 {0} 筆翻譯快取",
    "importTranslationCacheFailed": "已匯入 {0} 筆，但有 {1} 筆無法儲存。儲存空間可能已滿",
    "exportTranslationCacheEmpty": "目前沒有翻譯快取",
    "clearTranslationCache": "清除翻譯快取",
    "clearTranslationCacheSuccess": "已成功清除翻譯快取",
    "clearTranslationCacheConfirm": "這會刪除所有翻譯快取項目，且無法復原。確定要繼續嗎？",
    "loading": "載入中",
    "autoTranslateCachedOnly": "只自動翻譯已有翻譯快取的訊息",
    "notification": "通知",
    "permissionDenied": "瀏覽器或作業系統拒絕權限",
    "customFlags": "自訂旗標",
    "enableCustomFlags": "啟用自訂旗標",
    "googleCloudTokenization": "Google Cloud Tokenization",
    "presetChain": "預設集隨機切換",
    "legacyMediaFindings": "舊版媒體搜尋",
    "staticsDisclaimer": "統計資料僅基於 2024 年 7 月之後的資料，可能不完全準確",
    "subtitles": "字幕",
    "subtitlesWarning1": "使用此功能時，模型必須支援音訊／影片輸入",
    "subtitlesWarning2": "使用此功能時，模型必須支援串流",
    "reset": "重設",
    "assetMaxDifference": "資源比對最大距離",
    "sourceLanguage": "原文語言",
    "destinationLanguage": "目標語言",
    "noWebGPU": "您的瀏覽器或作業系統不支援 WebGPU，效能會明顯下降",
    "menuSideBar": "側邊選單",
    "home": "首頁",
    "showSavingIcon": "顯示儲存中圖示",
    "pluginVersionWarn":
        "此外掛版本為 {{plugin_version}}，與目前 Risuai 版本不相容。請將外掛更新至 {{required_version}}",
    "imageTranslation": "圖片翻譯",
    "banCharacterset": "出現指定字元集時自動重新產生",
    "realmDirectOpen": "直接在 RisuRealm 開啟角色",
    "showPromptComparison": "顯示提示詞比較",
    "inlayErrorResponse": "內嵌錯誤回應",
    "triggerOn": "Trigger 時機",
    "noConfig": "無設定",
    "varName": "變數名稱",
    "var": "變數",
    "condition": "條件",
    "trigger": "Trigger",
    "outputVar": "輸出變數",
    "source": "來源",
    "cmd": "指令",
    "sysStart": "系統開始",
    "sysHistoryEnd": "系統歷史結束",
    "sysPromptEnd": "系統提示詞結束",
    "target": "目標",
    "addElse": "加入 Else",
    "min": "最小值",
    "max": "最大值",
    "delimiter": "分隔符號",
    "deleteCount": "刪除數量",
    "triggerEffRunAxLLM": "執行輔助模型",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 是同時使用摘要與向量搜尋的長期記憶系統",
        "supaMemoryPromptPlaceHolder": "留空以使用預設值",
        "maxMemoryTokensRatioLabel": "最大記憶 Token 比例（估算）",
        "maxMemoryTokensRatioError": "無法計算最大記憶 Token 比例",
        "memoryTokensRatioLabel": "記憶 Token 比例",
        "extraSummarizationRatioLabel": "額外摘要比例",
        "maxChatsPerSummaryLabel": "每份摘要最大訊息數",
        "queryChatCountLabel": "相似度查詢使用的近期訊息數",
        "summaryChunkSeparatorLabel": "摘要區塊分隔用 Regex",
        "recentMemoryRatioLabel": "近期記憶比例",
        "similarMemoryRatioLabel": "相似記憶比例",
        "randomMemoryRatioLabel": "隨機記憶比例",
        "enableSimilarityCorrectionLabel": "啟用相似度修正",
        "preserveOrphanedMemoryLabel": "保留原始訊息已被刪除的摘要",
        "applyRegexScriptWhenRerollingLabel": "重新產生時套用 Regex 腳本",
        "doNotSummarizeUserMessageLabel": "不摘要使用者訊息",
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3",
        "resetConfirmMessage": "此操作無法復原。要重設 HypaV3 資料嗎？",
        "resetConfirmSecondMessage": "此操作無法復原。再次確認：確定要重設 HypaV3 資料嗎？",
        "convertLabel": "目前還沒有摘要，但可以將 HypaV2 資料轉換成 V3",
        "convertButton": "轉換為 V3",
        "convertSuccessMessage": "已成功將 HypaV2 資料轉換成 V3",
        "convertErrorMessage": "無法將 HypaV2 資料轉換成 V3：{0}",
        "noSummariesLabel": "目前沒有摘要",
        "searchPlaceholder": "輸入 #N、ID 或搜尋內容",
        "summaryNumberLabel": "摘要 #{0}",
        "deleteThisConfirmMessage": "要刪除此摘要嗎？",
        "deleteAfterConfirmMessage": "要刪除此摘要之後的所有摘要嗎？",
        "deleteAfterConfirmSecondMessage": "此操作無法復原。真的確定嗎？",
        "translationLabel": "翻譯",
        "rerolledSummaryLabel": "重新產生的摘要",
        "rerolledTranslationLabel": "重新產生摘要的翻譯",
        "connectedMessageCountLabel": "已連結訊息（{0}）",
        "connectedFirstMessageLabel": "第一則訊息",
        "connectedMessageRoleLabel": "{0} 的訊息",
        "connectedMessageNotFoundLabel": "找不到訊息",
        "connectedMessageLoadingError": "載入已連結訊息時發生錯誤：{0}",
        "connectedMessageTranslationLabel": "翻譯",
        "nextSummarizationFirstMessageLabel": "第一則訊息",
        "nextSummarizationNoMessageIdLabel": "沒有訊息 ID",
        "nextSummarizationLabel": "HypaV3 接下來會摘要 [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "警告：找不到訊息",
        "nextSummarizationLoadingError": "載入下一個摘要目標時發生錯誤：{0}",
        "summarizationConditionLabel": "提示：當輸入 Token 超過最大上下文長度時，HypaV3 會開始進行摘要",
        "emptySelectedFirstMessageLabel": "警告：選取的第一則訊息是空的",
        "unclassified": "未分類",
        "reSummarize": "重新摘要",
        "reSummarizing": "正在重新摘要...",
        "reSummarizeResult": "重新摘要結果",
        "retry": "重試",
        "translate": "翻譯",
        "tag": "標籤",
        "tagManager": "標籤管理",
        "tagManagerTitle": "標籤管理 - 摘要 #{0}",
        "newTagName": "新標籤名稱",
        "noTagsYet": "目前沒有標籤",
        "addNewTagHint": "在上方加入新標籤",
        "categoryManager": "分類",
        "allCategories": "全部",
        "categoryName": "分類名稱",
        "noCategoriesYet": "目前沒有分類",
        "addNewCategoryHint": "按下上方的 + 按鈕新增分類",
    },
    "bulkEnabling": "Lorebook 批次啟用",
    "showTranslationLoading": "顯示「翻譯中」提示",
    "showDeprecatedTriggerV1": "顯示已棄用的 Trigger V1",
    "showDeprecatedTriggerV2": "顯示已棄用的 Trigger V2",
    "triggerV1Warning": "Trigger V1 已棄用，未來可能會被移除",
    "copy": "複製",
    "paste": "貼上",
    "depth": "深度",
    "returnCSSError": "回傳 CSS 錯誤",
    "alwaysActiveInChat": "一律啟用（目前對話）",
    "childLoreDesc": "這是角色 Lorebook 條目的副本，會維持「一律啟用」，直到此副本被移除，或原始條目被手動停用",
    "thinkingTokens": "思考 Token",
    "thinkingType": "思考模式",
    "adaptiveThinkingEffort": "自動調整思考強度",
    "antiServerOverload": "防伺服器過載",
    "localActivationInGlobalLorebook": "允許在個別對話啟用角色 Lorebook 條目",
    "cachePoint": "快取點",
    "all": "全部",
    "showFolderNameInIcon": "在圖示中顯示資料夾名稱",
    "claudeCachingRetrival": "延長 Claude 快取",
    "claudeCachingRetrivalDesc":
        "每 4 分鐘送出一次請求，以延長 Claude 快取的有效時間。這可降低快取未命中率，但若使用不當，也可能增加成本",
    "automaticCachePoint": "自動快取點",
    "experimentalChatCompression": "實驗性對話資料處理",
    "loadingChatData": "正在載入對話資料",
    "outputImageModal": "輸出圖片視窗",
    "playMessageOnTranslateEnd": "翻譯完成後播放音訊",
    "auxModelUnderModelSettings": "在模型設定中，顯示各輔助功能的使用模型",
    "seperateModelsForAxModels": "為各輔助功能分別設定模型",
    "axModelsDef": "Ax 模型定義",
    "doNotChangeSeperateModels": "切換預設集時，不要變更各輔助功能的模型",
    "tools": "工具",
    "action": "操作",
    "hotkey": "快捷鍵",
    "hotkeyDesc": {
        "reroll": "重新產生",
        "unreroll": "復原重新產生",
        "translate": "翻譯",
        "remove": "移除",
        "edit": "編輯",
        "copy": "複製",
        "send": "送出",
        "settings": "設定",
        "home": "首頁",
        "presets": "快速選擇預設集",
        "persona": "快速選擇使用者人設",
        "modelSelect": "快速選擇模型",
        "toggleCSS": "切換 CSS",
        "prevChar": "上一個角色",
        "nextChar": "下一個角色",
        "quickMenu": "快速選單",
        "quickSettings": "快速設定",
        "toggleVoice": "切換語音",
        "toggleLog": "切換記錄",
        "previewRequest": "預覽請求",
        "import": "匯入",
        "export": "匯出",
        "webcam": "切換網路攝影機",
        "focusInput": "聚焦輸入框",
        "scrollToActiveChar": "捲動至目前角色",
        "popupEditor": "彈出式編輯器",
        "loadout": "設定組合",
    },
    "screenTooSmall": "螢幕太小，無法顯示此介面",
    "advancedModelSettings": "進階模型設定",
    "fallbackModel": "Fallback 模型",
    "fallbackWhenBlankResponse": "空白回應時使用 Fallback",
    "doNotChangeFallbackModels": "切換預設集時不要變更 Fallback 模型",
    "customModels": "自訂模型",
    "igpPrompt": "IGP 提示詞",
    "useTokenizerCaching": "使用 Tokenizer 快取",
    "hypaMemoryV2Modal": "Hypa V2 視窗",
    "hypaMemoryV3Modal": "Hypa V3 視窗",
    "showMenuHypaMemoryModal": "在選單顯示 Hypa 視窗",
    "promptInfoInsideChat": "將提示詞資訊儲存至對話",
    "promptTextInfoInsideChat": "將提示詞文字儲存至對話",
    "promptInfoEmptyMessage": "此訊息沒有可用的提示詞資訊",
    "promptInfoEmptyToggle": "目前沒有啟用任何自訂開關",
    "promptInfoEmptyText": "尚未儲存提示詞文字",
    "escapeOutput": "跳脫輸出",
    "openAIFlexProcessing": "OpenAI Flex Processing",
    "claudeBatching": "Claude Batching",
    "claude1HourCaching": "Claude 1 小時快取",
    "folderNameInput": "請輸入新的資料夾名稱",
    "folderRemoveLengthError": "要移除資料夾，資料夾內不能包含任何項目",
    "personaNotePlaceholder": "在此輸入用來區分此使用者人設的唯一識別。例如：「獵人人設」",
    "mcpAccessPrompt": '{{tool}} 正嘗試執行「{{action}}」。要允許嗎？',
    "rememberToolUsage": "記住工具使用權限",
    "simplifiedToolUse": "簡化工具使用",
    "toolCalled": "已呼叫工具「{{tool}}」",
    "static": "靜態",
    "dynamic": "動態",
    "assetStyle": "資源樣式",
    "insertAssetPrompt": "插入資源提示詞",
    "requestLocation": "請求位置",
    "newImageHandlingBeta": "新版圖片處理（Beta）",
    "settingsExported": "Bug 回報用設定已匯出並複製至剪貼簿",
    "bookmarks": "書籤",
    "noBookmarks": "沒有書籤",
    "bookmarkAskNameOrDefault": "輸入書籤名稱。若留空，系統會自動命名",
    "bookmarkAskNameOrCancel": "輸入書籤名稱。若留空，將取消重新命名",
    "collapseAll": "全部收合",
    "expandAll": "全部展開",
    "noRequestLogs": "沒有可用的請求記錄",
    "hideErrorDetails": "隱藏錯誤詳細資訊",
    "showErrorDetails": "顯示錯誤詳細資訊",
    "dynamicOutput": "動態輸出",
    "autoAdjustSchema": "自動調整 Schema",
    "dynamicMessages": "動態訊息",
    "dynamicMemory": "動態記憶",
    "dynamicResponseTiming": "動態回應時機",
    "showTypingEffect": "顯示「正在輸入」指示",
    "dynamicRequest": "動態請求",
    "dynamicOutputPrompt": "動態輸出提示詞",
    "settingsCloseButtonSize": "設定視窗關閉按鈕大小",
    "translating": "翻譯中...",
    "stackTraceTranslationFailed": "無法翻譯堆疊追蹤。以下顯示原始的混淆版堆疊追蹤",
    "apply": "套用",
    "add": "加入",
    "nightlyWarning":
        "## 測試版\n\n您目前使用的是測試版。此版本僅供測試，可能包含尚未修正的問題。**測試版不提供個別問題排除支援**",
    "loginSionyw": "使用 Sionyw 帳號登入",
    "pluginRiskDetectedAlert": "Risuai 偵測到可能有害的程式碼，**可能竊取您的 API 金鑰或個人資料**。強烈建議**不要安裝此外掛**",
    "doNotInstall": "不要安裝",
    "continueAnyway": "仍要繼續",
    "pluginNoRiskButAlert": "Risuai 未偵測到有害程式碼，但從不可信來源安裝外掛仍可能帶來安全風險",

    "pluginRisksInuserFriendly": {
        "eval": "從字串執行程式碼",
        "globalAccess": "存取全域變數",
        "thisOutsideClass": "在 class 範圍外使用 `this`",
        "errorInVerification": "驗證過程發生錯誤",
        "storageAccess": "存取儲存空間",
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "此外掛嘗試執行字串中的程式碼；字串可能經過混淆，用來隱藏惡意程式碼",
        "globalAccess": "此外掛嘗試存取全域變數，可能造成非預期副作用或安全漏洞",
        "thisOutsideClass": "此外掛在 class 範圍外使用 `this`，可能造成非預期行為或安全問題",
        "errorInVerification": "外掛驗證過程中發生錯誤，可能代表功能或安全性存在問題",
        "storageAccess": "此外掛嘗試存取儲存空間，可能導致資料外洩或未授權的資料修改",
    },
    "generatedByAIDisclaimer": "此內容由 AI 生成，可能包含不準確資訊或偏見",
    "aiGenerationWarning": "內容將由 AI 生成，可能包含不準確資訊或偏見",
    "duplicatePluginFoundUpdateIt": "已安裝相同外掛。要更新現有外掛嗎？",
    "pluginUpdateFoundInstallIt": "發現外掛更新。要安裝更新嗎？",
    "goToChat": "前往對話",
    "bookmark": "書籤",
    "translate": "翻譯",
    "branch": "分支",
    "branchedText": "此對話由 {} 分支而來",
    "loadMore": "載入更多",
    "disableMessage": "停用訊息",
    "disableAbove": "從此處截斷提供給 AI 的訊息",
    "autoScrollToNewMessage": "自動捲動至新訊息",
    "alwaysScrollToNewMessage": "永遠捲動至新訊息（忽略目前捲動位置）",
    "newMessage": "新訊息",
    "newMessageButtonStyle": "新訊息按鈕樣式",
    "newMessageButtonBottomCenter": "底部中央（預設）",
    "newMessageButtonBottomRight": "右下角",
    "newMessageButtonBottomLeft": "左下角",
    "newMessageButtonFloatingCircle": "浮動圓形按鈕（右下角）",
    "newMessageButtonRightCenter": "右側中央",
    "newMessageButtonTopBar": "頂端列",
    "trimStartNewChat": "略過「開始新對話」系統標記",
    "pluginDevelopMode": "外掛開發模式",
    "fetchLogConsent": "外掛 {} 正要求讀取記錄，其中可能包含敏感資訊。要允許嗎？",
    "getFullDatabaseConsent": "外掛 {} 正要求存取完整資料庫，其中可能包含敏感資訊。要允許嗎？",
    "mainDomAccessConsent": "外掛 {} 正要求存取 Risuai 主介面的 DOM，其中可能包含敏感資訊。要允許嗎？",
    "replacerPermissionConsent": "外掛 {} 正要求替換對話內容的權限，這可能被用來操控對話。要允許嗎？",
    "providerPermissionConsent": "外掛 {} 正要求使用模型供應商功能，這可能讓它發出未經授權的 API 請求。要允許嗎？",
    "inlayPermissionConsent": "外掛 {} 正要求存取內嵌內容，這可能讓它讀取、寫入或編輯內嵌資料。要允許嗎？",
    "sendChatConsent": "外掛 {} 正要求以您的名義送出對話訊息，這會觸發 AI 回應。要允許嗎？",
    "pluginV2Warning": "外掛 V2 與 V2.1 被視為不安全，並會在未來版本停止運作。**請勿使用這些版本的外掛。** 若您是此外掛的開發者，請儘快升級至 V3",
    "createFolderOnBranch": "在分支上建立資料夾",
    "hamburgerButtonBottom": "將選單按鈕移至側邊欄底部",
    "partialBackupFirstConfirm": "⚠️ 警告：部分本機備份 ⚠️\n\n此備份只會快速儲存必要資訊。\n\n會包含：\n- 資料庫（對話紀錄、角色、模組、外掛、提示詞、設定等）\n- 角色頭像（主要圖片）\n- 使用者頭像與自訂背景\n- 人設頭像\n- 資料夾圖片\n- 提示詞預設集圖片\n\n⚠️ 不會包含：\n- 情緒立繪\n- 額外角色資源\n- VITS 語音檔案\n- 其他所有額外媒體檔案\n\n此備份檔案**不包含所有角色資源**！\n若需要完整備份，請使用一般本機備份。\n\n確定要繼續嗎？",
    "partialBackupSecondConfirm": "⚠️⚠️ 最後警告 ⚠️⚠️\n\n此備份只會儲存角色個人檔案頭像、資料夾圖片，其他資源不會儲存！\n\n會儲存：\n- 資料庫（對話紀錄、角色、模組、外掛、提示詞、設定等）\n- 角色頭像（主要圖片）\n- 使用者頭像與自訂背景\n- 人設頭像\n- 資料夾圖片\n- 提示詞預設集圖片\n\n不會儲存：\n- 情緒立繪\n- 額外角色資源\n- VITS 語音檔案\n- 其他所有媒體檔案\n\n⚠️ 只有在您**不需要**備份檔中的角色資源時才應繼續！⚠️\n\n真的確定要進行部分備份嗎？",
    "savePartialLocalBackup": "儲存部分本機備份（不含角色資源）",
    "pluginProviderNotFound": "偵測到未知外掛。請更換模型，或啟用對應的外掛",
    "bootstrap": {
        "dataCorruptionDetected": (name: string, type: string) => `偵測到資料損毀\n\n模組「${name}」的 Lorebook 格式已損毀。\n\n損毀資料類型：${type}`,
        "reportErrorQuestion": "要將此錯誤回報給開發者嗎？\n這有助於避免相同錯誤再次發生。\n（只包含已損毀模組的資訊，不包含個人資料）",
        "diagnosticInformation": (reportData: string) => `# 診斷資訊\n\n請複製下方資訊，透過 GitHub Issues、Discord 或社群回報給開發者。\n送出前請再次確認其中沒有敏感資訊。\n\n\`\`\`json\n${reportData}\n\`\`\``,
        "resetLorebookQuestion": "只重設此特定損毀模組中的 Lorebook 資料嗎？\n（其他模組與角色資料**不會**受到影響）\n\n選擇「否」會保留資料，但錯誤可能持續發生",
    },
    "partialEdit": {
        "editButtonTooltip": "編輯",
        "deleteButtonTooltip": "刪除",
        "deleteModalTitle": "確認刪除",
        "deleteConfirmMessage": "確定要刪除此部分嗎？",
        "deleteYes": "是",
        "deleteNo": "否",
        "editModalTitle": "局部編輯",
        "matchFound": (method: string) => `比對方式：${method}`,
        "matchFailedTitle": "無法局部編輯",
        "matchFailedMessage": "無法在原始訊息中精確找到這段內容。句子過長或內容重複時可能發生此情況，請改用完整訊息編輯",
        "selectMatch": "選擇要編輯的區塊",
        "selectDeleteMatch": "選擇要刪除的區塊",
        "matchesFound": "個相符結果",
        "lineNumber": (line: number) => `約第 ${line} 行`,
        "saveShortcut": "儲存（Ctrl+Enter）",
        "cancelShortcut": "取消（Esc）",
        "save": "儲存",
        "cancel": "取消",
    },
    "enableRemoteSaving": "啟用遠端儲存",
    "blockquoteStyling": "引用區塊樣式",
    "dynamicModelRegistry": "動態模型註冊",
    "confirmInstallPluginViaPlugin": "您正嘗試透過另一個外掛安裝此外掛。若來源外掛不可信，可能會帶來安全風險。確定要繼續嗎？",
    "risuaiProTools": "Risuai Pro Tools",
    "enableRisuaiProTools": "啟用 Risuai Pro Tools",
    "easyPanel": "Easy Panel",
    "mainModel": "主要模型",
    "epEnabled": "Easy Panel 覆寫",
    "epRequirementsNotMet": "目前設定不符合 Easy Panel 的需求。按下方按鈕即可自動調整相關選項，套用 Easy Panel 的建議設定",
    "seperateParametersByModel": "依模型分別設定參數",
    "disableSeperateParameterChangeOnPresetChange": "切換預設集時不要變更獨立參數設定",
    "keepSessionAlive": "維持工作階段",
    "keepSessionAlivePip": "透過子母畫面（PiP）",
    "keepSessionAliveSound": "透過音訊",
    // NanoGPT Dashboard
    "nanoGPTLoadingAccountInfo": "正在載入帳號資訊…",
    "nanoGPTCreditBalance": "帳戶餘額：",
    "nanoGPTSubscription": "訂閱",
    "nanoGPTGraceUntil": (date: string) => `寬限期至 ${date}`,
    "nanoGPTNoActiveSubscription": "目前沒有有效訂閱",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `將於本期結束時取消（${date}）`,
    "nanoGPTWeeklyTokens": (pct: string) => `每週內含輸入 Token 額度 — 已使用 ${pct}`,
    "nanoGPTDailyTokens": (pct: string) => `每日內含輸入 Token 額度 — 已使用 ${pct}`,
    "nanoGPTDailyImages": (pct: string) => `每日內含圖片額度 — 已使用 ${pct}`,
    "nanoGPTResets": (date: string) => `於 ${date} 重設`,
    "nanoGPTUsed": (n: string) => `已使用 ${n}`,
    "nanoGPTRemaining": (n: string) => `剩餘 ${n}`,
    "nanoGPTRenews": (date: string) => `續訂：${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "無法載入帳號資訊",
    "nanoGPTWeeklyTokensLabel": "每週內含輸入 Token 額度",
    "nanoGPTDailyTokensLabel": "每日內含輸入 Token 額度",
    "nanoGPTDailyImagesLabel": "每日內含圖片額度",
    "nanoGPTUsedLabel": "已使用",
    "nanoGPTRemainingLabel": "剩餘",
    "nanoGPTResetsLabel": "重設",
    "nanoGPTRenewsLabel": "續訂：",
    // NanoGPT Provider Picker
    "nanoGPTProvider": "供應商",
    "nanoGPTProviderPayAsYouGoOnly": "（僅適用於隨用隨付模式）",
    "nanoGPTProviderAuto": "自動",
    "nanoGPTProviderFree": "免費",
    "nanoGPTProviderInput": "輸入",
    "nanoGPTProviderOutput": "輸出",
    "nanoGPTProviderQuantization": "量化",
    "nanoGPTProviderUndisclosed": "未公開",
    "nanoGPTProviderCache": "快取",
    "nanoGPTProviderCacheSupported": "支援",
    "nanoGPTProviderCacheNotSupported": "不支援",
    "nanoGPTProviderCacheRead": "快取讀取",
    // NanoGPT Settings
    "nanoGPTUseSubscriptionEndpoint": "使用訂閱專用端點與模型",
    // Model Grid
    "modelGridCouldNotLoad": "無法載入模型清單。請檢查您的 API 金鑰",
    "modelGridNoModelsMatch": (q: string) => `找不到符合「${q}」的模型`,
    "modelGridContext": (n: string) => `上下文：${n}`,
    "loadouts": "設定組合",
    "loadout": "設定組合",

    "nanoGPTSelectFromList": "從清單中選擇",
    "nanoGPTManualInput": "手動輸入",
    "nanoGPTManualModelSelect": "手動選擇模型",
    "coldStorage": "冷儲存",
    "cleanColdStorage": "清理未使用的冷儲存資料",
    "customSidebarConfig": "自訂側邊欄設定",
    "cleanColdStorageConfirm": "這會永久刪除所有未使用的冷儲存資料。其中可能包含目前未使用、但未來仍有用的資料。確定要繼續嗎？",
    "moveInsteadOfCopyOnCMPConvert": "CMP 轉換時以移動取代複製",
    "successfullyConverted": "轉換成功",
    "convertToModule": "轉換為模組",
    "skipSavingAssetsOnWebSync": "Web Sync 時略過儲存資源",
    "applyAdditionalParamsToAll": "將額外參數套用至所有模型",
    "localToggles": "本對話獨立設定",
} satisfies DeepPartial<typeof import('./en').languageEnglish>
